import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { storedDateForDisplay } from '@app/shared/stored-date';
import { swedishTimestamp } from '@app/shared/swedish-time';
import { environment as env } from '@env/environment';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { Location } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ICompany } from '@app/core/interfaces/ICompany';
import { IContact } from '@app/core/interfaces/IContact';
import { IInvoice } from '@app/core/interfaces/IInvoice';
import { IFile } from '@app/core/interfaces/IFile';
import { IDeduction } from '@app/core/interfaces/invoice/IDeduction';
import { IAllowance } from '@app/core/interfaces/invoice/IAllowance';
import { EditCustomerDialogComponent } from '../../shared/customer/EditCustomerDialog.Component';
import { EditDeductionDialogComponent } from '../../static/invoice-tool/deduction/edit-deduction-Dialog.Component';
import { EditAllowanceDialogComponent } from '../../static/invoice-tool/allowance/edit-allowance-Dialog.Component';
import { EditContactDialogComponent } from '../../shared/contact/EditContactDialog.Component';
import { LoginDialogComponent } from '../../shared/login-dialog/LoginDialog.Component';
import { ModalSpinnerDialogComponent } from '../../shared/modal-spinner/ModalSpinnerDialog.Component';
import { InvoiceToolCalendarDialogComponent } from './invoice-tool.calendarDialog.Component';
import { InvoicePreviewDialogComponent } from './invoice-tool.invoicePreviewDialog.Component'
import { CompanyService } from '@app/core/services/CompanyService';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { AuthenticationService } from '@app/core/services/AuthenticationService';
import { CurrencyService } from '@app/core/services/CurrencyService';
import { UserService } from '@app/core/services/UserService';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { IAccountSettings } from '@app/core/interfaces/user/IAccountSettings';
import { IConfirmResponse } from '@app/core/interfaces/confirm/IConfirmResponse';
import { IUser } from '@app/core/interfaces/user/IUser';
import { AddMissingRecieverDialogComponent } from './addreciever/add-missing-reciever-Dialog.Component';
import { IFileType } from '@app/core/interfaces/IFileType';
import { FileService } from '@app/core/services/FileService';
import { FormControl, Validators } from "@angular/forms";
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/ConfirmDialog';
import { IBank } from '@app/core/interfaces/economy/IBank';
import { BankService } from '@app/core/services/BankService';
import { SwedishBankAccountValidationService } from '@app/core/services/SwedishBankAccountValidationService';
import { IDiscountCode, DiscountCategory, DiscountType } from '@app/core/interfaces/IDiscountCode';
import { EmployerTaxService } from '@app/core/services/EmployerTaxService';
import { calculatePension } from '@app/core/services/pension-calculation';
import { catchError, firstValueFrom, Observable, of, timeout } from 'rxjs';

@Component({
  standalone: false,
  selector: 'invoice-tool',
  templateUrl: './invoice-tool.component.html',
  styleUrls: ['./invoice-tool.component.scss']
})

export class InvoiceToolComponent implements OnInit {
  private readonly invoiceItemGroupType = 'InvoiceItem';
  private readonly workedHoursGroupType = 'WorkedHours';
  panelOpenStateSalaryShares = false;
  panelOpenStateAllowances = false;
  panelOpenStateDeductions = false;
  invoiceExpenseToggleOpen = false;
  invoiceAttachmentsToggleOpen = false;
  payoutDeductionsToggleOpen = false;
  payoutAllowancesToggleOpen = false;
  payoutPensionToggleOpen = false;
  payoutSalarySharesToggleOpen = false;
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  versions = env.versions;
  public appId: number = env.appId;
  public bankIdUrl = env.bankIdUrl;
  id: number;
  companies = [];
  companiesLoaded: boolean = false;
  currencies = [];
  public searchAccountValue: string;
  hoursWorkedTotal: number = 0;
  TotalInvoiceAmount: number = 0;
  ref: IContact = { Id: 0, Address: "", City: "", Email: "", Name: "", NameLocked: false, Phone: "", Zip: "", IDNumber: "" };
  invoice = {
    Id: 0,
    Allowances: [],
    DiscountCodes: [], // Lista för att spara giltiga koder
    ReferenceText: null,
    InvoiceFee: 0,
    ExpressPayOut: false,
    RotDrivingFee: 3,
    RotDrivingFeeTotalAmount: 0,
    IsRot: false, IsRut: false,
    IsRotRut: false,
    RotProperty: null,
    RotDrivingFeeKm: 0,
    Marking: '',
    RecieverEmailCopy: '',
    RecieverEmailReminder: '',
    WorkCountry: 'Sverige',
    CreditInvoiceFor: null,
    ExpressPayout: false,
    Status: { TechnicalName: 'Draft', Order: 0 },
    User: { Id: "0" },
    InvoiceGroups: [],
    Messages: [],
    Message: undefined,
    TravelExpenses: { Reciepts: [], TravelReportTotalAmount: 0, DriveJournalTotalAmount: 0 },
    PaymentTerm: "30",
    PaymentDue: null as string | Date | null,
    SalaryShares: [],
    selectedReference: "",
    ShowDeductions: false,
    ShowMileDeduction: false,
    TravelDistance: undefined,
    Deductions: [],
    invoiceItemGroup: [],
    Reference: this.ref,
    RecieverEmail: '',
    termsAgreed: false,
    Customer: { Id: 0, Active: true, Name: '', OrgNumber: '', AcceptsInvoiceFee: true, TimeReportMandatory: false, NameLocked: false, AcceptsInvoiceFeeLocked: false, Address: '', AddressLocked: false, Zip: '', ZipLocked: false, City: '', CityLocked: false, ElectronicReference: '', ElectronicReferenceMandatory: false, GlnNumber: null, GlnNumberLocked: false, Country: { Id: null, Name: null, Eu: false }, Reference: {}, InvoiceEmail: '', InvoiceEmailLocked: false, InvoiceSendType: 0, PaymentTerm: 0, PaymentTermLocked: false, InvoiceSendTypeLocked: false, Contacts: [], IsCompany: false, PublicInfo: "" },
    Currency: { Id: "1", Name: "SEK" },
    InvoiceSendMethodEmail: true,
    InvoiceSendMethodMail: false,
    InvoiceSendType: 1, action: '',
    RecieverCompanyName: '',
    RecieverAddress1: '',
    RecieverZip: '',
    RecieverCity: '',
    SelectedCurrency: 'SEK',
    SubInvoices: [],
    FeePaidByReciever: true,
    TotalInvoiceAmount: 0,
    SubInvoice: false,
    PensionSavingsAmount: 0,
    PensionSavingsFactor: 0,
    Documents: [],
    ReverseTax: false,
    Type: { Name: '', TechnicalName: ''},
    UserSettings: {
      Id: "",
      AccountNumber: 0,
      PensionSavingsSettings: {
        Id: 0,
        Amount: 0,
        Unit: {
          Id: 0,
          TechnicalName: ''
        },
        PensionSavingsCompany: {
          TechnicalName: ''
        }
      }
    },
    PayoutDate: Date,
    CustomerCopy: { Id: 0, Active: true, Name: '', OrgNumber: '', AcceptsInvoiceFee: true, TimeReportMandatory: false, NameLocked: false, AcceptsInvoiceFeeLocked: false, Address: '', AddressLocked: false, Zip: '', ZipLocked: false, City: '', CityLocked: false, ElectronicReference: '', ElectronicReferenceMandatory: false, GlnNumber: null, GlnNumberLocked: false, Country: { Id: null, Name: null }, Reference: {}, InvoiceEmail: '', InvoiceEmailLocked: false, InvoiceSendType: 0, PaymentTerm: 0, PaymentTermLocked: false, InvoiceSendTypeLocked: false, Contacts: [], IsCompany: false, PublicInfo: "" },
  };
  invoiceQuickGroupTemplate = {
    Description: '',
    Vat: "25",
    ReverseTax: false,
    VatNoSwe: "0",
    TimeReportStatus: { DisplayName: "Ingen tid", Id: "3", Name: "NoInfo" },
    PaymentReciever: { Id: "", Name: null, PersonalNumber: null, OrgNumber: null, IsCompany: false, LastLogin: null, User: null },
    Type: {},
    rowTypeSelected: "1",
    InvoiceRows: []
  };
  invoiceQuickGroup = JSON.parse(JSON.stringify(this.invoiceQuickGroupTemplate));
  contacts = [];
  contactsLoaded: boolean = false;
  vatList = [];
  salaryShare = [];
  invoiceShareTypes = [];
  addToInvoiceList = [{ Name: 'Ja', Value: true }, { Name: 'Nej', Value: false }];
  paymentTerms = [10, 15, 20, 25, 30, 45, 60];
  sendTypes: any[] = [{ Id: 1, Name: "Epost (pdf)" }, { Id: 3, Name: "EDI" }];
  isLoading = true;
  messageSending = false;
  userInfoSaving = false;
  invoiceGroupSaving = false;
  skipTimeReporting = false;
  isAdmin = false;
  feePaidByReciever: boolean = true;
  feePaidBySender: boolean = false;
  showValidationSummary: boolean = false;
  submitType: number = 0;
  invoiceSendTypeMail: boolean = false;
  invoiceSendTypeEmail: boolean = true;
  DueDate: number;
  today: Date;
  PaymentTermInt: any;
  //statusOrder = 0;
  //DiscountCode = "Corona2020";
  ReadOnlyCheckbox: boolean;
  resultMarking: number;
  resultDescription: number;
  txt: any;
  text: any;
  str: any;
  sumNetExpenses: number = 0;
  sumFees: number = 0;
  preliminaryPayout: number = 0;
  ExpressPayoutLocal: boolean = false;
  dialogSpinner: any = null;
  RotDrivingFee: number = 3;
  ErrorMessageTab: any;
  ErrorMessageDesc: string = '';
  ErrorMessageSend: any;
  errorMessagePension: string = '';
  errorMessagePensionSavingsCompany: string = '';
  pensionValidates: boolean = true;
  errorMessageSaveQuickRow: string = '';
  hasSubInvoices: boolean = false;
  sendInfo: boolean = false;
  personalOrOrgNumberValid: boolean = false;
  invoiceFeeLocked: boolean = false;
  recieverEmailLocked: boolean = false;
  invoiceSendTypeLocked: boolean = false;
  electronicReferenceMandatory: boolean = false;
  quickrowValid: boolean = false;
  sendInvoiceValidates: boolean = false;
  errorMessageFiles: string = '';
  totalFileSize: number = 0;
  attachedFilesCount: number = 0;
  pensionSavingsFactorPreset: number = 0;
  pensionSavingsAmountPreset: number = 0;
  pensionSavingsFactor: number = 0;
  pensionSavingsPercent: number = 0;
  pensionSavingsAmount: number = 0;
  user: IUser;
  CustomServiceFee = 0;
  Commission = 0;
  pensionSavingsTotalAmount = 0;
  pensionSavingsTaxFactor = 0.2426;
  IsCommissionInvoice = false;
  showExpressDialog: boolean = false;
  recieverEmailValid: boolean = true;
  recieverEmailCopyValid: boolean = true;
  recieverEmailReminderValid: boolean = true;
  ErrorMessageRecieverEmail: string = '';
  ErrorMessageRecieverCopyEmail: string = '';
  ErrorMessageRecieverReminderEmail: string = '';
  Suspended: boolean = false;
  pensionSavingsCompanies: any;
  invoiceSender: any;
  pensionSavingsCompanyId: number = 3; //Inget valt
  rutRotValidates: boolean = true;
  userLoadedFlag: boolean = false; // Flag to track completion of user loading
  invoiceLoadedFlag: boolean = false;  // Flag to track completion of invoice loading
  invoiceViewReady: boolean = false;
  draftInitializedOnOpen: boolean = false;
  shareAmountExceedsTotal: boolean = false;
  sharePercentExceedsTotal: boolean = false;
  shareTypeDifferent: boolean = false;
  public banks: IBank[];
  bankInfoNeedsUpdate: boolean = false;
  bankEntryMode: 'swedish' | 'personkonto' | 'international' = 'swedish';
  bankValidationMessage = '';
  private bankValidationTimer: ReturnType<typeof setTimeout> | null = null;
  code: string | null = null;
  DiscountCategory = DiscountCategory;
  DiscountType = DiscountType;
  ContactEmailApprovedForExpress = false;
  userEmailNeedsUpdate: boolean = false;
  userPersonalNumberNeedsUpdate: boolean = false;
  userPhoneNumberNeedsUpdate: boolean = false;
  missingPersonalNumber: string = '';
  missingEmail: string = '';
  missingPhone: string = '';
  userInfoNeedsUpdate: boolean = false;

  previousReverseTaxValue: boolean = false;
  reverseTaxTemp: boolean = false;
  referralCode: boolean = false;
  referralDiscountText: string = '';
  serviceFeeFactor: number = 0;
  preliminarySalaryLoading: boolean = false;
  preliminarySalaryError: string = '';
  preliminarySalaryCalculation: any = null;

  @ViewChild('rbExpressPayoutYes', { static: false }) rbExpressPayoutYes: MatRadioButton;
  @ViewChild('rbExpressPayoutNo', { static: false }) rbExpressPayoutNo: MatRadioButton;
  @ViewChild('preliminarySalaryDialog', { static: false }) preliminarySalaryDialog: TemplateRef<any>;
  @ViewChild('vatInformationDialog', { static: false }) vatInformationDialog: TemplateRef<any>;

  constructor(
    private router: Router,
    private _location: Location,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private companyService: CompanyService,
    private invoiceService: InvoiceService,
    private currencyService: CurrencyService,
    private loadingService: LoadingBarService,
    private userService: UserService,
    private employerTaxService: EmployerTaxService,
    private bankService: BankService,
    private swedishBankAccountValidationService: SwedishBankAccountValidationService,
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    public fileService: FileService,
    public snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) { }

  @ViewChild('expressBankIdDialog', { static: true }) expressBankIdDialog: TemplateRef<any>;
  @ViewChild('expressPayoutDialog', { static: true }) expressPayoutDialog: TemplateRef<any>;

  expressPayoutTooltip = 'Utbetalas direkt efter bekräftat underlag.';

  ngOnInit() {
    this.openLoadingSpinner();
    this.loadingService.start();
    this.loadCurrencies();
    this.invoiceService.getGlobalServiceFee(true).subscribe({
      next: value => {
        const factor = Number(value);
        if (value != null && Number.isFinite(factor) && factor >= 0) {
          const percent = (factor * 100).toLocaleString('sv-SE');
          this.expressPayoutTooltip = `Utbetalas direkt efter bekräftat underlag, kostnad är ${percent} % av fakturabeloppet.`;
        }
      },
      error: error => console.error('Kunde inte hämta Expressavgiften.', error)
    });
    this.getBanks();
    this.resultDescription = 0;
    this.resultMarking = 0;
    this.reverseTaxTemp = this.invoice.ReverseTax;
    this.syncReverseTax();

    this.route.queryParams.subscribe(params => {
      this.showExpressDialog = params['showExpressDialog'] ? true : false;
    });

    this.route.params.subscribe(params => {
      this.skipTimeReporting = false;
      this.id = params['id'] ? params['id'] : 0;
      this.loadInvoice(this.id);
    });

    this.loadUser(); // Load user data

    this.isAdmin = this.userService.userHasRole("admin");
    this.PaymentTermInt = parseInt(this.invoice.PaymentTerm);
    this.today = new Date();
    this.DueDate = new Date().setDate(this.today.getDate() + this.PaymentTermInt);
    this.ReadOnlyCheckbox = true;

    if (this.isAdmin) {
      this.ReadOnlyCheckbox = false;
    }

    this.updateTotalInvoiceAmount();
    this.sendValidates();
  }

  sendMessage(message: string) {
    if (this.messageSending) {
      return;
    }

    this.messageSending = true;
    this.invoiceService.sendMessage(message, this.id)
      .subscribe(
        response => {
          this.messageSending = false;
          this.messageSent(response);
        },
        error => {
          this.messageSending = false;
          console.log(error);
        });
  }

  cancel() {
    if (confirm("Vill du lämna utan att spara några ändringar i fakturan?")) {
      this._location.back();
    }
  }

  messageSent(message: any) {
    this.invoice.Message = undefined;
    this.invoice.Messages.push(message);
  }

  loadUser() {
    this.userService.getCurrentUser()
      .subscribe(
        value => {
          this.userLoaded(value); // Set user data
          this.userLoadedFlag = true; // Mark user as loaded
          this.setUserSettings(); // Call setUserSettings
        },
        error => console.log(error)
      );
  }

  addDiscountCode(code: string) {    

    if (this.invoice.DiscountCodes == null)
      this.invoice.DiscountCodes = [];
       
    if (this.invoice.DiscountCodes.some(d => d.Code === code)) { 
      alert(`Koden "${code}" är redan inlöst.`);
      this.code = null;
      return;
    }

    this.invoiceService.getDiscountCode(code).subscribe({ 
      next: response => {
        this.invoice.DiscountCodes.push(response);
        this.code = null;
      },
      error: (err: Error) => {
        alert(`Koden kunde inte tillämpas: ${err.message}`);
      }
    });
  }


  removeDiscountCode(index: number) {
    this.invoice.DiscountCodes.splice(index, 1); // möjlighet att ta bort koder
  }

  userLoaded(user: IUser) {
    this.user = user;
  }

  getBanks() {
    this.bankService.getAll()
      .subscribe(response => {
        this.banks = response;
        if (this.bankInfoNeedsUpdate) { this.syncResolvedBankFromAccountDetails(); }
      }, err => alert(err));
  }

  onBankEntryModeChange(mode: 'swedish' | 'personkonto' | 'international') {
    this.cancelPendingBankValidation();
    this.bankEntryMode = mode;
    if (!this.invoiceSender.Bank) {
      this.invoiceSender.Bank = { Id: 0 } as IBank;
    }
    this.bankValidationMessage = '';

    if (mode === 'international') {
      const internationalBank = this.banks?.find((bank) => bank.Id === 2);
      if (internationalBank) {
        this.invoiceSender.Bank = JSON.parse(JSON.stringify(internationalBank));
        this.invoiceSender.BankName = internationalBank.Name;
      }
      return;
    }

    this.invoiceSender.Bic = '';
    this.invoiceSender.Iban = '';

    if (mode === 'personkonto') {
      const nordeaPersonkonto = this.banks?.find((bank) => bank.Id === 5);
      if (nordeaPersonkonto) {
        this.invoiceSender.Bank = JSON.parse(JSON.stringify(nordeaPersonkonto));
        this.invoiceSender.BankName = nordeaPersonkonto.Name;
      }
      this.invoiceSender.ClearingNumber = '';
      this.invoiceSender.AccountNumber = this.getNordeaPersonkontoAccountNumber();
      this.syncResolvedBankFromAccountDetails();
      return;
    }

    if (this.invoiceSender.Bank?.Id === 2 || this.invoiceSender.Bank?.Id === 5) {
      this.invoiceSender.Bank.Id = 0;
      this.invoiceSender.Bank.Name = 'Välj bank';
      this.invoiceSender.Bank.IsInternational = false;
      this.invoiceSender.BankName = '';
    }

    this.syncResolvedBankFromAccountDetails();
  }

  onClearingNumberChange(value: string) {
    this.invoiceSender.ClearingNumber = value;
    this.resolveBankFromClearing();
    this.scheduleBankValidation();
  }

  onAccountNumberChange(value: string) {
    if (this.bankEntryMode === 'personkonto') {
      this.invoiceSender.AccountNumber = this.getNordeaPersonkontoAccountNumber();
      this.scheduleBankValidation();
      return;
    }

    this.invoiceSender.AccountNumber = value;
    this.scheduleBankValidation();
  }

  scheduleBankValidation(): void {
    this.cancelPendingBankValidation();
    this.bankValidationMessage = '';
    this.bankValidationTimer = setTimeout(() => {
      this.bankValidationTimer = null;
      this.syncResolvedBankFromAccountDetails();
      this.cdr.detectChanges();
    }, 3000);
  }

  private cancelPendingBankValidation(): void {
    if (this.bankValidationTimer != null) {
      clearTimeout(this.bankValidationTimer);
      this.bankValidationTimer = null;
    }
  }

  onAccountNumberFocus() {
    this.syncResolvedBankFromAccountDetails();
  }

  getClearingHint(): string {
    if (this.bankEntryMode !== 'swedish') {
      return '';
    }

    if (this.invoiceSender?.Bank?.ClearingNumberValidationErrorText) {
      return this.invoiceSender.Bank.ClearingNumberValidationErrorText;
    }

    return 'Ange 4 eller 5 siffror.';
  }

  getAccountHint(): string {
    if (this.bankEntryMode === 'personkonto') {
      return 'Kontonumret hämtas automatiskt från personnumrets sista 10 siffror.';
    }

    if (this.bankEntryMode === 'international') {
      return '';
    }

    if (this.invoiceSender?.Bank?.AccountNumberValidationErrorText) {
      return this.invoiceSender.Bank.AccountNumberValidationErrorText;
    }

    return 'Ange kontonummer.';
  }

  private resolveBankFromClearing(): void {
    if (this.bankEntryMode !== 'swedish' || !this.invoiceSender || !this.banks?.length) {
      return;
    }

    const resolvedBankFromClearing = this.swedishBankAccountValidationService.resolveBankFromClearing(
      this.banks,
      this.invoiceSender.ClearingNumber
    );

    this.invoiceSender.BankName = resolvedBankFromClearing.resolvedBankName || '';

    if (resolvedBankFromClearing.resolvedBank) {
      this.invoiceSender.Bank = JSON.parse(JSON.stringify(resolvedBankFromClearing.resolvedBank));
      this.invoiceSender.ClearingNumber = resolvedBankFromClearing.normalizedClearingNumber;
    } else if (this.invoiceSender.Bank && !this.invoiceSender.Bank.IsInternational) {
      this.invoiceSender.Bank.Id = 0;
      this.invoiceSender.Bank.Name = 'Välj bank';
    }
  }

  private syncResolvedBankFromAccountDetails() {
    if (this.bankValidationTimer != null) {
      return;
    }

    if (!this.invoiceSender || !this.banks || this.banks.length === 0) {
      return;
    }

    if (this.bankEntryMode === 'international' || this.invoiceSender.Bank?.IsInternational) {
      const bic = (this.invoiceSender.Bic || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
      const iban = (this.invoiceSender.Iban || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
      this.bankValidationMessage = !/^[A-Z]{6}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/.test(bic)
        ? 'Du måste ange ett giltigt BIC (8 eller 11 tecken)'
        : (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban)
          ? 'Du måste ange ett giltigt IBAN (15–34 tecken)' : '');
      return;
    }

    if (this.bankEntryMode === 'personkonto') {
      this.invoiceSender.ClearingNumber = '';
      this.invoiceSender.AccountNumber = this.getNordeaPersonkontoAccountNumber();

      if (!this.invoiceSender.AccountNumber || this.invoiceSender.AccountNumber === '') {
        this.bankValidationMessage = 'Ange personnummer med 12 siffror för Nordea personkonto.';
        this.invoiceSender.BankName = 'Nordea personkonto';
        return;
      }

      const result = this.swedishBankAccountValidationService.validate(
        this.banks,
        null,
        this.invoiceSender.AccountNumber,
        this.getBankPersonalNumber()
      );

      this.invoiceSender.BankName = 'Nordea personkonto';
      if (result.resolvedBank) {
        this.invoiceSender.Bank = JSON.parse(JSON.stringify(result.resolvedBank));
        this.invoiceSender.AccountNumber = result.normalizedAccountNumber;
      }

      this.bankValidationMessage = result.isValid ? '' : result.message;
      return;
    }

    if ((!this.invoiceSender.ClearingNumber || this.invoiceSender.ClearingNumber === '') && (!this.invoiceSender.AccountNumber || this.invoiceSender.AccountNumber === '')) {
      this.bankValidationMessage = '';
      this.invoiceSender.BankName = '';
      return;
    }

    this.resolveBankFromClearing();

    if (!this.invoiceSender.AccountNumber || this.invoiceSender.AccountNumber === '') {
      this.bankValidationMessage = '';
      return;
    }

    const result = this.swedishBankAccountValidationService.validate(
      this.banks,
      this.invoiceSender.ClearingNumber,
      this.invoiceSender.AccountNumber,
      this.getBankPersonalNumber()
    );

    if (result.resolvedBank) {
      this.invoiceSender.Bank = JSON.parse(JSON.stringify(result.resolvedBank));
      this.invoiceSender.BankName = result.resolvedBankName || this.invoiceSender.BankName || '';
      this.invoiceSender.ClearingNumber = result.normalizedClearingNumber;
      this.invoiceSender.AccountNumber = result.normalizedAccountNumber;
      this.bankValidationMessage = result.isValid ? '' : result.message;
      return;
    }

    this.bankValidationMessage = result.message;
    if (this.invoiceSender.Bank && !this.invoiceSender.Bank.IsInternational) {
      this.invoiceSender.Bank.Id = 0;
      this.invoiceSender.Bank.Name = 'Välj bank';
    }
  }

  private getBankPersonalNumber(): string {
    return this.userPersonalNumberNeedsUpdate ? this.missingPersonalNumber : this.invoiceSender?.PersonalNumber;
  }

  private getNordeaPersonkontoAccountNumber(): string {
    const personalNumber = (this.getBankPersonalNumber() || '').replace(/\D+/g, '');
    return personalNumber.length >= 10 ? personalNumber.slice(-10) : '';
  }

  onMissingPersonalNumberChange(value: string): void {
    this.missingPersonalNumber = value;
    if (this.bankEntryMode === 'personkonto') {
      this.invoiceSender.AccountNumber = this.getNordeaPersonkontoAccountNumber();
      this.scheduleBankValidation();
    }
  }

  ngOnDestroy(): void {
    this.cancelPendingBankValidation();
  }

  bankOnChange(bankId) {

    for (var i = 0; i < this.banks.length; i++) {
      if (this.banks[i].Id == bankId) {
        this.invoiceSender.Bank = JSON.parse(JSON.stringify(this.banks[i]));
      }
    }
  }

  getPensionSavingsCompanies() {
    if (this.invoiceSender.PensionSavingsSettings.PensionSavingsCompany == null) {
      this.loadPensionSavingsCompanies();
    }
  }

  loadPensionSavingsCompanies() {
    this.userService.getPensionSavingsCompanies()
      .subscribe(value => this.pensionSavingsCompaniesLoaded(value),
        error => console.log(error)
      );
  }

  pensionSavingsCompaniesLoaded(pensionSavingsCompanies: any) {
    this.pensionSavingsCompanies = pensionSavingsCompanies;
  }

  pensionSavingsCompanyChanged(event: any) {

    if (event == 1) {
      //SPP
      this.invoiceSender.PensionSavingsSettings.PensionSavingsCompany.Id = 1;
    }
    else if (event == 2) {
      //Avanza
      this.invoiceSender.PensionSavingsSettings.PensionSavingsCompany.Id = 2;
    }
    else {
      //Inget valt
      this.invoiceSender.PensionSavingsSettings.PensionSavingsCompany.Id = 3;
    }

    this.validatePensionSavingsCompany();
  }

  get pensionSavingsAmountForDisplay(): number {
    return this.pensionSavingsAmount || 0;
  }

  setPensionSavingsAmount() {
    if (!this.user) return;

    const isNewInvoice = this.invoice.Id === 0;
    const isForeignCurrency = this.isForeignCurrencyInvoice();

    if (!isNewInvoice) {
      // Use values already set on the invoice
      this.pensionSavingsAmount = this.invoice.PensionSavingsAmount;
      this.pensionSavingsFactor = this.invoice.PensionSavingsFactor || 0;
      this.pensionSavingsPercent = this.pensionSavingsFactor > 0 ? this.pensionSavingsFactor * 100 : 0;
      this.pensionSavingsTotalAmount = Math.round(this.pensionSavingsAmount * (1 + this.pensionSavingsTaxFactor));
      return;
    }

    // For new invoice: use default settings from the sender
    const settings = this.invoiceSender.PensionSavingsSettings;
    const unit = settings.Unit.TechnicalName;
    const amount = settings.Amount;

    if (unit === 'Percent') {
      this.pensionSavingsFactor = amount / 100;
      this.pensionSavingsFactorPreset = amount;
      this.pensionSavingsPercent = amount;
      // pensionSavingsAmount will be calculated inside update
    } else if (unit === 'Share' && !isForeignCurrency) {
      this.pensionSavingsAmount = amount;
      this.pensionSavingsAmountPreset = amount;
      this.pensionSavingsTotalAmount = Math.round(amount * (1 + this.pensionSavingsTaxFactor));
    }

    this.updatePensionSavingsAmount();
    this.invoice.PensionSavingsAmount = this.pensionSavingsAmount;
  }

  private validateFixedPensionAmount(): boolean {
    const fixed = !(this.pensionSavingsPercent > 0);
    const unchanged = this.invoice.Id > 0 && !this.invoice.PensionSavingsFactor
      && this.pensionSavingsAmount === this.invoice.PensionSavingsAmount;
    if (fixed && !Number.isInteger(this.pensionSavingsAmount || 0) && !unchanged) {
      this.pensionValidates = false;
      this.setErrorMessagePension('Fasta pensionsbelopp ska anges i hela SEK.');
      return false;
    }
    return true;
  }

  get pensionLimitWarning(): string {
    if (!this.invoice || this.invoice.CreditInvoiceFor != null) return '';
    if (this.pensionSavingsPercent > 10) {
      return 'Pensionsavsättningen överstiger max 10 % av slutgiltig bruttolön.';
    }
    if (this.pensionSavingsPercent > 0 || !(this.pensionSavingsAmount > 0)) return '';
    const maximum = this.getMaxPensionSavingsAmountExclTax();
    if (maximum === null) return 'Pensionsgränsen kan inte kontrolleras innan skatteuppgifterna har hämtats.';
    return this.pensionSavingsAmount > maximum
      ? 'Pensionsavsättningen överstiger max ' + maximum + ' kr (10 % av slutgiltig bruttolön).' : '';
  }

  private validatePensionLimit(): boolean {
    if (this.pensionLimitWarning && !this.isAdmin) {
      this.pensionValidates = false;
      this.ErrorMessageSend = this.pensionLimitWarning;
      this.sendInvoiceValidates = false;
      this.showValidationSummary = true;
      return false;
    }
    return true;
  }

  updatePensionSavingsAmount(type: string = null) {

    this.pensionValidates = true;
    if (this.isForeignCurrencyInvoice() && type == 'Amount') {
      this.pensionSavingsAmount = 0;
      this.pensionSavingsTotalAmount = 0;
      this.invoice.PensionSavingsAmount = 0;
      this.invoice.PensionSavingsFactor = 0;
      return;
    }

    if (type === 'Amount') this.pensionSavingsPercent = 0;
    this.pensionSavingsFactor = this.pensionSavingsPercent / 100;
    if (!this.validateFixedPensionAmount()) return;

    if (this.TotalInvoiceAmount > 0) {

      this.calculatePreliminaryPayout();
      var payoutMinusNetExpenses = this.getPreliminaryPensionSavingsBaseAmount();

      //If percent is chosen as calculating factor
      if ((type == 'Share' || this.pensionSavingsFactor > 0) && type != 'Amount') {
        this.getMaxPensionSavingsAmountExclTax();
        if (!this.pensionLimitTaxContext) {
          this.pensionValidates = false;
          this.setErrorMessagePension('Pensionen kan inte beräknas innan skatteuppgifterna har hämtats.');
          return;
        }
        const { selectedTax, normalTax, paidGrossSalary } = this.pensionLimitTaxContext;
        const pension = calculatePension(payoutMinusNetExpenses, this.pensionSavingsFactor,
          this.pensionSavingsTaxFactor, selectedTax.Tax, normalTax ? normalTax.Tax : null,
          Math.max(0, 25000 - paidGrossSalary));
        this.pensionSavingsTotalAmount = Math.round(pension * (1 + this.pensionSavingsTaxFactor));
        this.pensionSavingsAmount = Math.round(this.pensionSavingsTotalAmount / (1 + this.pensionSavingsTaxFactor));
      }
      else {
        this.pensionSavingsTotalAmount = Math.round(this.pensionSavingsAmount * (1 + this.pensionSavingsTaxFactor));
        this.pensionSavingsPercent = 0;
      }

      if (this.invoice.CreditInvoiceFor == null) {

        this.setErrorMessagePension("");
        if (!this.validatePensionLimit()) return;
        this.invoice.PensionSavingsAmount = this.pensionSavingsAmount;
        this.invoice.PensionSavingsFactor = this.pensionSavingsFactor;
      }

      this.validatePensionSavingsCompany();
    }
    else {
      this.setErrorMessagePension("Du behöver fakturera något innan du kan ange pension");
    }
  }

  private getPreliminaryPensionSavingsBaseAmount(): number {
    const invoice = this.invoice as unknown as IInvoice;
    if (invoice.SubInvoice) {
      return Math.max(0, Number(invoice.TotalInvoiceAmount || 0) - this.sumNetExpenses
        - (Math.sign(invoice.ServiceFee || 0) * Math.round(Math.abs(invoice.ServiceFee || 0))) - Number(invoice.InvoiceFee || 0)
        - Number(invoice.ExchangeFee || 0) - Number(invoice.ReminderFee || 0)
        - Number(invoice.InkassoFee || 0) - Number(invoice.KronofogdenFee || 0)
        - Number(invoice.CustomFee || 0) + Number(invoice.ManualDiscount || 0));
    }
    var preliminaryPayout = this.preliminaryPayout || 0;

    return Math.max(0, preliminaryPayout - this.sumNetExpenses);
  }

  private pensionLimitTaxKey: string = '';
  private pensionLimitTaxContext: { selectedTax: any, normalTax: any, paidGrossSalary: number } | null = null;

  getMaxPensionSavingsAmountExclTax(): number | null {
    this.calculatePreliminaryPayout();
    const invoice = this.invoice as unknown as IInvoice;
    // Subinvoices already contain their allocated fees. Do not estimate a new
    // service fee or add the ordinary invoice fee to their salary budget.
    const salaryBudget = this.getPreliminaryPensionSavingsBaseAmount();
    if (salaryBudget <= 0) {
      return 0;
    }
    const userId = this.invoiceSender?.Id;
    if (!userId) {
      return null;
    }
    const storedPayoutDate = invoice.PayoutDate ? new Date(invoice.PayoutDate) : null;
    const payoutDate = storedPayoutDate && !isNaN(storedPayoutDate.getTime())
      ? storedPayoutDate
      : this.getPreliminarySalaryCalculationDates().payoutDate;
    const checkZeroTax = (salaryBudget + this.sumNetExpenses) < 1000;
    const key = `${userId}:${this.invoice.Id}:${payoutDate.getFullYear()}:${payoutDate.getMonth()}:${checkZeroTax}`;
    if (this.pensionLimitTaxKey !== key) {
      this.pensionLimitTaxKey = key;
      this.pensionLimitTaxContext = null;
      void this.loadPensionLimitTaxes(key, userId, payoutDate, checkZeroTax);
    }
    if (!this.pensionLimitTaxContext) {
      return null;
    }
    const { selectedTax, normalTax, paidGrossSalary } = this.pensionLimitTaxContext;
    // At the maximum, pension = 10% of the final gross salary. Pension tax
    // and employer tax must both fit in the same salary budget.
    const maximumPension = calculatePension(salaryBudget, 0.10, this.pensionSavingsTaxFactor,
      selectedTax.Tax, normalTax ? normalTax.Tax : null, Math.max(0, 25000 - paidGrossSalary));
    const maxInclTax = Math.round(maximumPension * (1 + this.pensionSavingsTaxFactor));
    return Math.round(maxInclTax / (1 + this.pensionSavingsTaxFactor));
  }

  private async loadPensionLimitTaxes(key: string, userId: string, payoutDate: Date, checkZeroTax: boolean): Promise<void> {
    try {
      const selectedTax = await firstValueFrom(this.userService.getUserEmployerTax(userId, checkZeroTax).pipe(timeout(5000)));
      if (!selectedTax || selectedTax.Tax == null || !Number.isFinite(Number(selectedTax.Tax))) {
        throw new Error('Missing employer tax for pension limit.');
      }
      let normalTax = null;
      let paidGrossSalary = 0;
      if (selectedTax.Name === 'TempYouth') {
        const [taxes, paid] = await Promise.all([
          firstValueFrom(this.employerTaxService.getEmployerTaxes().pipe(timeout(5000))),
          firstValueFrom(this.userService.getUserPayoutGrossSalaryInMonth(userId, payoutDate,
            this.invoice.Id > 0 ? this.invoice.Id : undefined).pipe(timeout(5000)))
        ]);
        normalTax = taxes.find(t => t.Name === 'Normal' && (!selectedTax.Year || t.Year === selectedTax.Year));
        if (!normalTax || !Number.isFinite(Number(paid?.grossSalary))) {
          throw new Error('Missing monthly employer tax basis for pension limit.');
        }
        paidGrossSalary = Number(paid.grossSalary);
      }
      if (this.pensionLimitTaxKey === key) {
        this.pensionLimitTaxContext = { selectedTax, normalTax, paidGrossSalary };
        if (this.pensionSavingsFactor > 0) {
          this.updatePensionSavingsAmount('Share');
        }
      }
    } catch (error) {
      console.error('Kunde inte beräkna högsta pensionsavsättning.', error);
    } finally {
      this.cdr.markForCheck();
    }
  }

  private setErrorMessagePension(message: string): void {
    setTimeout(() => {
      this.errorMessagePension = message;
    }, 0);
  }

  validatePensionSavingsCompany() {
    if (this.invoice.Status.TechnicalName !== 'Draft' && this.requiresPensionSavingsCompany()) {
      this.errorMessagePensionSavingsCompany = "Du måste ange ett företag för din pensionsavsättning";
      this.pensionValidates = false;
    }
    else {
      this.errorMessagePensionSavingsCompany = "";
    }
  }

  requiresPensionSavingsCompany(): boolean {
    return this.hasPensionSavings() && !this.hasSelectedPensionSavingsCompany();
  }

  private hasPensionSavings(): boolean {
    return Number(this.pensionSavingsTotalAmount || 0) > 0 ||
      Number(this.pensionSavingsAmount || 0) > 0 ||
      Number(this.pensionSavingsPercent || 0) > 0 ||
      Number(this.invoice?.PensionSavingsAmount || 0) > 0 ||
      Number(this.invoice?.PensionSavingsFactor || 0) > 0;
  }

  private hasSelectedPensionSavingsCompany(): boolean {
    const settingsCompanyId = Number(this.invoiceSender?.PensionSavingsSettings?.PensionSavingsCompany?.Id || 0);
    const companyId = settingsCompanyId > 0 ? settingsCompanyId : Number(this.pensionSavingsCompanyId || 0);
    return companyId !== 0 && companyId !== 3;
  }

  ngOnChanges() {
    this.syncReverseTax(); // if invoice or invoiceQuickGroup changes
  }

  syncReverseTax() {
    this.reverseTaxTemp = (this.invoice && this.invoice.ReverseTax != null)
      ? this.invoice.ReverseTax
      : false;
  }

  get quickGroupVat(): string {
    if (!this.invoice?.Customer?.Id) {
      return null;
    }

    return this.isSwedishCustomer() ? this.invoiceQuickGroup.Vat : this.invoiceQuickGroup.VatNoSwe;
  }

  set quickGroupVat(value: string) {
    if (this.isSwedishCustomer()) {
      this.invoiceQuickGroup.Vat = value;
    } else {
      this.invoiceQuickGroup.VatNoSwe = value;
    }
  }

  private isSwedishCustomer(customer: any = this.invoice?.Customer): boolean {
    const countryName = customer && customer.Country && customer.Country.Name
      ? String(customer.Country.Name).trim().toLowerCase()
      : '';
    const countryId = Number(customer && customer.Country ? customer.Country.Id : 0);
    return countryName === 'sverige' || countryId === 1;
  }

  private isEuCustomer(customer: any = this.invoice?.Customer): boolean {
    return !this.isSwedishCustomer(customer)
      && !!(customer && customer.Country && customer.Country.Eu === true);
  }

  private isReverseTaxAllowedForCustomer(customer: any = this.invoice?.Customer): boolean {
    return this.isSwedishCustomer(customer) && !!(customer && customer.IsCompany === true);
  }

  private getAllowedVatValues(customer: any = this.invoice?.Customer): string[] {
    if (this.isAdmin) {
      return ['25', '12', '6', '0'];
    }

    if (this.isSwedishCustomer(customer)) {
      return ['25', '12', '6'];
    }

    if (this.isEuCustomer(customer)) {
      return ['0', '25'];
    }

    return ['0'];
  }

  private getDefaultVatValue(customer: any = this.invoice?.Customer): string {
    if (this.isAdmin) {
      return '25';
    }

    if (this.isSwedishCustomer(customer)) {
      return '25';
    }

    return '0';
  }

  private normalizeInvoiceItemVatForCustomer(currentVat: any, customer: any = this.invoice?.Customer, useDefault: boolean = false): string {
    const allowedVatValues = this.getAllowedVatValues(customer);
    const defaultVat = this.getDefaultVatValue(customer);
    const vatValue = currentVat != null ? String(currentVat) : '';

    if (useDefault) {
      return defaultVat;
    }

    return allowedVatValues.includes(vatValue) ? vatValue : defaultVat;
  }

  private applyCustomerVatRulesToQuickGroup(useDefault: boolean = false): void {
    if (!this.invoiceQuickGroup) {
      return;
    }

    this.invoiceQuickGroup.Vat = this.normalizeInvoiceItemVatForCustomer(this.invoiceQuickGroup.Vat, this.invoice.Customer, useDefault);
    this.invoiceQuickGroup.VatNoSwe = this.normalizeInvoiceItemVatForCustomer(this.invoiceQuickGroup.VatNoSwe, this.invoice.Customer, useDefault);

    if (!this.isReverseTaxAllowedForCustomer(this.invoice.Customer)) {
      this.invoiceQuickGroup.ReverseTax = false;
      this.invoice.ReverseTax = false;
      this.reverseTaxTemp = false;
    }
  }

  private applyCustomerVatRulesToInvoiceItems(useDefault: boolean = false): void {
    if (this.isAdmin || !this.invoice || !Array.isArray(this.invoice.InvoiceGroups)) {
      return;
    }

    this.invoice.InvoiceGroups.forEach(group => {
      const shouldTreatAsInvoiceItem = this.isInvoiceItemGroup(group)
        || (!this.usesLegacyInvoiceGroupMode() && !this.isWorkedHoursGroup(group));

      if (!shouldTreatAsInvoiceItem) {
        return;
      }

      group.Vat = this.normalizeInvoiceItemVatForCustomer(group && group.Vat, this.invoice.Customer, useDefault);

      if (!this.isReverseTaxAllowedForCustomer(this.invoice.Customer)) {
        group.ReverseTax = false;
      }
    });

    if (!this.isReverseTaxAllowedForCustomer(this.invoice.Customer)) {
      this.invoice.ReverseTax = false;
      this.reverseTaxTemp = false;
    }
  }

  getVatList() {
    this.vatList = this.getAllowedVatValues(this.invoice.Customer).map(value => ({ Value: value }));

    if (this.invoice.ReverseTax && this.isReverseTaxAllowedForCustomer(this.invoice.Customer)) {
      this.invoiceQuickGroup.Vat = "0";
      this.invoiceQuickGroup.VatNoSwe = "0";
      return;
    }

    this.applyCustomerVatRulesToQuickGroup(false);
  }

  currencyChanged() {
    for (var i = 0; i < this.currencies.length; i++) {
      var curr = this.currencies[i];
      if (curr.Id == this.invoice.Currency.Id) {
        this.invoice.Currency.Name = curr.Name;
      }
    }

    if (this.isForeignCurrencyInvoice() && this.pensionSavingsFactor == 0) {
      this.pensionSavingsAmount = 0;
      this.pensionSavingsTotalAmount = 0;
      this.invoice.PensionSavingsAmount = 0;
      this.invoice.PensionSavingsFactor = 0;
    }

    if (this.isForeignCurrencyInvoice()) {
      this.clearBillableExpenses();
    }

    this.disableExpressPayoutIfIneligible(true);
    this.updatePensionSavingsAmount();
  }

  private isForeignCurrencyInvoice(): boolean {
    return !!this.invoice && !!this.invoice.Currency && this.invoice.Currency.Name != 'SEK';
  }

  isExpressPayoutBlockedByDueDate(): boolean {
    if (!this.invoice?.PaymentDue) {
      return false;
    }

    const dueDate = storedDateForDisplay(this.invoice.PaymentDue);
    return !isNaN(dueDate.getTime())
      && dueDate.toISOString().slice(0, 10) <= swedishTimestamp().slice(0, 10);
  }

  showExpressPayoutDueDateWarning(): boolean {
    const invoice: any = this.invoice;
    return this.isExpressPayoutBlockedByDueDate()
      && invoice?.PayoutStatus?.TechnicalName !== 'PaidOut'
      && !['Paired', 'Credited'].includes(invoice?.Status?.TechnicalName);
  }

  canUseExpressPayout(): boolean {
    return this.isSwedishCustomer() && !this.isForeignCurrencyInvoice();
  }

  private getExpressPayoutEligibilityMessage(): string {
    if (!this.isSwedishCustomer() && this.isForeignCurrencyInvoice()) {
      return 'Expressutbetalning kan bara väljas för en svensk kund och när fakturans valuta är SEK.';
    }

    if (!this.isSwedishCustomer()) {
      return 'Expressutbetalning kan bara väljas för en svensk kund.';
    }

    return 'Expressutbetalning kan bara väljas när fakturans valuta är SEK.';
  }

  private disableExpressPayoutIfIneligible(showWarning: boolean): boolean {
    if (this.canUseExpressPayout()) {
      return false;
    }

    const wasExpress = !!this.invoice.ExpressPayOut;
    this.invoice.ExpressPayOut = false;
    this.ExpressPayoutLocal = false;
    this.updateExpressPayoutStatusUI(false);

    if (wasExpress) {
      this.loadGlobalServiceFee();
      this.updatePensionSavingsAmount();
      this.sendValidates();

      if (showWarning) {
        alert(this.getExpressPayoutEligibilityMessage() + ' Expressutbetalning har därför tagits bort.');
      }
    }

    return true;
  }

  shareTypeChanged(event: any, share: any) {

    if (event == 1) {
      share.Salary = 0;
      share.ShareType.Id = 1;
      share.ShareType.Name = "Procent";
    }
    else {
      share.Share = 0;
      share.ShareType.Id = 2;
      share.ShareType.Name = "Fakturabelopp";
    }

  }

  onReverseTaxChange(event: MatCheckboxChange) {
    const isChecked = event.checked;
    const wasChecked = this.invoice.ReverseTax;

    // Only show confirmation if there's a change
    if (isChecked !== wasChecked) {
      const confirmed = this.reverseTaxChange(isChecked, true);
      if (!confirmed) {
        event.source.checked = wasChecked; // Revert visual state
      } else {
        this.getVatList();
      }
    }
  }


  reverseTaxChange(checked: boolean, requireConfirm: boolean): boolean {
    const customer = this.invoice.Customer;
    if (!this.isReverseTaxAllowedForCustomer(customer)) {
      this.invoice.ReverseTax = false;
      this.reverseTaxTemp = false;
      this.applyCustomerVatRulesToInvoiceItems(true);
      this.applyCustomerVatRulesToQuickGroup(true);
      return true;
    }
    const previousValue = this.invoice.ReverseTax;

    if (requireConfirm && checked) {
      const confirmed = confirm("Detta alternativ kan endast användas om du utfört jobb inom byggsektorn.Är du säker på att du vill fortsätta? Alla rader du lagt till kommer få 0 % i moms.");
      if (!confirmed) return false;
    }

    if (requireConfirm && !checked && previousValue) {
      const confirmed = confirm("Alla dina fakturarader kommer nu få 25 % moms. Om detta inte stämmer behöver du ändra det på de rader det gäller.");
      if (!confirmed) return false;
    }

    // Apply confirmed or simple change
    this.reverseTaxTemp = checked;
    this.invoice.ReverseTax = checked;
    this.invoiceQuickGroup.Vat = checked ? "0" : this.getDefaultVatValue(customer);
    this.invoiceQuickGroup.VatNoSwe = checked ? "0" : this.getDefaultVatValue(customer);
    this.invoiceQuickGroup.ReverseTax = checked;

    this.invoice.InvoiceGroups.forEach(g => {
      const shouldTreatAsInvoiceItem = this.isInvoiceItemGroup(g)
        || (!this.usesLegacyInvoiceGroupMode() && !this.isWorkedHoursGroup(g));
      if (!shouldTreatAsInvoiceItem) {
        return;
      }

      g.Vat = checked ? "0" : this.normalizeInvoiceItemVatForCustomer(g && g.Vat, customer, true);
      g.ReverseTax = checked;
    });

    this.previousReverseTaxValue = checked;
    return true;
  }



  openLoadingSpinner() {
    this.dialogSpinner = this.dialog.open(ModalSpinnerDialogComponent, this.configSpinner);
  }

  // WordCounters
  wordCountDescription() {
    this.resultDescription = this.invoiceQuickGroup.Description.length;

    //this.txt = this.invoiceQuickGroup.Description.value;
    //this.text = this.txt.split(".");
    //this.str = this.text.join('.</br>');
  }

  wordCountMarking() {
    this.resultMarking = this.invoice.Marking ? this.invoice.Marking.length : 0;
  }

  loadInvoice(id: number) {

    this.invoiceViewReady = false;

    this.invoiceService.getInvoiceShareTypes()
      .subscribe(
        response => this.invoiceShareTypesLoaded(response),
        error => console.log(error));

    this.invoiceService.getInvoice(id)
      .subscribe(
        response => this.onGetInvoiceCompleted(response),
        error => console.log(error));
  }

  invoiceShareTypesLoaded(types) {
    this.invoiceShareTypes = types;
  }

  loadCurrencies() {
    this.currencyService.getCurrencies()
      .subscribe(
        response => {
          setTimeout(() => {
            this.currencies = response;
            this.cdr.detectChanges();
          }, 0);
        },
        error => console.log(error));
  }

  getGroupTotalHours(group: any) {
    var totalMinutes = 0;

    for (var i = 0; i < group.InvoiceRows.length; i++) {
      totalMinutes += parseInt(group.InvoiceRows[i].HoursWorked) * 60;
      totalMinutes += parseInt(group.InvoiceRows[i].MinutesWorked);
    }

    return this.time_convert(totalMinutes);
  }

  time_convert(num) {
    var hours = Math.floor(num / 60);
    var minutes = num % 60;

    if (minutes > 0) {
      return hours + " h " + minutes + " min";
    }
    else {
      return hours + " h";
    }

  }

  setUserSettings() {

    if (this.userLoadedFlag && this.invoiceLoadedFlag) {
      if (this.invoice.Id == 0) {
        this.invoiceSender = this.user;

      }
      else {
        this.invoiceSender = this.invoice.UserSettings;
      }

      this.bankEntryMode = this.invoiceSender.Bank?.IsInternational ? 'international'
        : (this.invoiceSender.Bank?.Id === 5 ? 'personkonto' : 'swedish');
      this.setPensionSavingsAmount();

      if (this.invoiceSender.PensionSavingsSettings != null && this.invoiceSender.PensionSavingsSettings.PensionSavingsCompany != null) {
        this.pensionSavingsCompanyId = this.invoiceSender.PensionSavingsSettings.PensionSavingsCompany.Id;
      }
      else {
        this.getPensionSavingsCompanies();
      }
      
      this.bankInfoNeedsUpdate = this.invoiceSender.Bank == null || this.invoiceSender.Bank.Id == 0 || this.invoiceSender.Bank.Id == null;
      this.userEmailNeedsUpdate = this.invoiceSender.Email == null || this.invoiceSender.Email.includes("tmpemail.com");
      this.userPersonalNumberNeedsUpdate = this.invoiceSender.PersonalNumber == null;
      this.userPhoneNumberNeedsUpdate = this.invoiceSender.Phone == null || this.invoiceSender.Phone.length < 5;

      if (this.bankInfoNeedsUpdate) { this.syncResolvedBankFromAccountDetails(); }

      if (this.invoiceSender.Suspended) {
        this.Suspended = true;
      }

      this.CustomServiceFee = this.invoiceSender.CustomServiceFee * 100;
      this.Commission = this.invoiceSender.Commission * 100;
      this.initializePayoutToggleDefaults();
      this.tryCreateDraftOnOpen();
    }
  }

  private tryCreateDraftOnOpen() {
    if (!this.userLoadedFlag || !this.invoiceLoadedFlag || this.draftInitializedOnOpen || this.id > 0 || this.invoice.Id > 0) {
      return;
    }

    this.draftInitializedOnOpen = true;
    this.isLoading = true;
    this.invoice.Status = { ...(this.invoice.Status || {}), TechnicalName: 'Draft', Order: 0 };

    this.invoiceService.createInvoice(this.invoice, null, undefined)
      .subscribe(response => this.onDraftInitializedOnOpen(response), error => {
        console.log(error);
        this.draftInitializedOnOpen = false;
        this.isLoading = false;
      });
  }

  private onDraftInitializedOnOpen(response: any) {
    if (response == null || response.Id == null || response.Id == 0) {
      this.draftInitializedOnOpen = false;
      this.isLoading = false;
      return;
    }

    this.id = response.Id;
    this.router.navigate(['/invoice-tool', response.Id], { replaceUrl: true, queryParamsHandling: 'preserve' });
  }

  isInvoiceCreated(): boolean {
    return Number(this.id) > 0 || Number(this.invoice?.Id) > 0;
  }

  private initializePayoutToggleDefaults() {
    const deductions = Array.isArray(this.invoice?.Deductions) ? this.invoice.Deductions : [];
    const allowances = Array.isArray(this.invoice?.Allowances) ? this.invoice.Allowances : [];
    const salaryShares = Array.isArray(this.invoice?.SalaryShares) ? this.invoice.SalaryShares : [];
    const pensionAmount = Number(this.invoice?.PensionSavingsAmount || this.pensionSavingsAmount || 0);
    const pensionFactor = Number(this.invoice?.PensionSavingsFactor || 0);

    this.invoiceExpenseToggleOpen = deductions.some(deduction => deduction?.AddedToInvoice === true)
      || allowances.some(allowance => allowance?.AddedToInvoice === true);
    this.payoutDeductionsToggleOpen = deductions.length > 0;
    this.payoutAllowancesToggleOpen = allowances.length > 0;
    this.payoutSalarySharesToggleOpen = salaryShares.length > 0;
    this.payoutPensionToggleOpen = pensionAmount > 0 || pensionFactor > 0;
  }

  onGetInvoiceCompleted(invoice: any) {

    this.invoice = invoice;
    this.enforceSingleWorkedHoursGroup(false);
    const workCountry = this.toWorkCountryName(this.invoice.WorkCountry).trim();
    if (workCountry === '') {
      this.invoice.WorkCountry = this.invoice.Customer?.Country?.Name || 'Sverige';
    } else {
      this.invoice.WorkCountry = workCountry;
    }
    this.resultMarking = this.invoice.Marking ? this.invoice.Marking.length : 0;

    this.invoiceLoadedFlag = true; // Mark invoice as loaded

    this.setUserSettings(); // Call setUserSettings

    // Defer UI state changes to avoid ExpressionChangedAfterItHasBeenCheckedError.
    setTimeout(() => {
      this.isLoading = false;
      this.invoiceViewReady = true;
      this.cdr.detectChanges();
      if (this.dialogSpinner) {
        this.dialogSpinner.close();
      }
    }, 0);
    this.invoice.Currency.Id = this.invoice.Currency.Id.toString();
    this.ExpressPayoutLocal = this.invoice.ExpressPayOut;
    this.disableExpressPayoutIfIneligible(false);
    this.loadGlobalServiceFee();

    if (this.invoice.Id > 0) {
      this.setPensionSavingsAmount();
    }
    //this.reverseTaxChange(this.invoice.ReverseTax, false);

    if (!this.invoice.SubInvoice) {
      if (this.invoice.Customer && this.invoice.Customer.Id > 0) {
        this.companies = [this.invoice.Customer];
        this.companiesLoaded = true;
      }
      this.getCompanyContacts(this.invoice.Customer.Id);
      this.getCompanies();
      this.checkReferenceEmail(this.invoice.Reference.Email);
    }

    if (this.invoice.Allowances == null)
      this.invoice.Allowances = [];

    this.setTotalHoursWorked();
    // Backfill billed mileage sum if missing on loaded invoices
    if (this.invoice.Allowances && this.invoice.Allowances.length > 0) {
      for (let k = 0; k < this.invoice.Allowances.length; k++) {
        const a = this.invoice.Allowances[k];
        if (a && a.AllowanceType && (a.AllowanceType.Id == '1' || a.AllowanceType.Id == 1)) {
          if (a.CustomReimbursementPerKm && a.CustomReimbursementPerKm !== 0 && (!a.sumCustomReimbursementPerKm || a.sumCustomReimbursementPerKm === 0)) {
            const mileage = a.Mileage || 0;
            a.sumCustomReimbursementPerKm = mileage * a.CustomReimbursementPerKm;
          }
        }
      }
    }
    // Recompute total invoice amount to include allowances/deductions
    this.updateTotalInvoiceAmount();
    this.getInvoicePaymentTerm();
    //this.invoice.PaymentTerm = (this.invoice.PaymentTerm == undefined || this.invoice.PaymentTerm == "0") ? "30" : this.invoice.PaymentTerm.toString();

    if (this.invoice.TravelDistance > 0) {
      this.invoice.ShowMileDeduction = true;
    }

    if (this.invoice.Deductions.length > 0) {
      this.invoice.ShowDeductions = true;
    }

    for (let deduction of this.invoice.Deductions) {
      deduction.IncludeInInvoice = deduction.IncludeInInvoice;
    }

    if (this.invoice.FeePaidByReciever == undefined || this.invoice.FeePaidByReciever) {
      this.feePaidByReciever = true;
      this.feePaidBySender = false;
    }
    else {
      this.feePaidBySender = true;
      this.feePaidByReciever = false;
    }

    this.invoice.TravelExpenses.TravelReportTotalAmount = this.invoice.TravelExpenses.TravelReportTotalAmount == 0 ? undefined : this.invoice.TravelExpenses.TravelReportTotalAmount;
    this.invoice.TravelExpenses.DriveJournalTotalAmount = this.invoice.TravelExpenses.DriveJournalTotalAmount == 0 ? undefined : this.invoice.TravelExpenses.DriveJournalTotalAmount;

    this.loadingService.complete();

    if (this.invoice.SubInvoices != null && this.invoice.SubInvoices.length > 0) {
      this.hasSubInvoices = true;
    }

    if (this.invoice.Customer != null) {
      this.setLockedValues(this.invoice.Customer);

      if (this.invoice.Customer.InvoiceSendType > 0) {
        if (this.invoice.InvoiceSendType == 2) {
          this.invoice.InvoiceSendType = 1;
        }
        else {
          this.invoice.InvoiceSendType = this.invoice.Customer.InvoiceSendType;
        }
      }
      else if (this.invoice.InvoiceSendType == 2) {
        this.invoice.InvoiceSendType = 1;
      }
      else if (this.invoice.InvoiceSendType == 3) {
        //Invoice send type is already set.
      }
      else {
        this.invoice.InvoiceSendType = 1;
      }
    }

    if (this.invoice.Type != null && this.invoice.Type.TechnicalName == "CommissionCashInvoice") {

      this.IsCommissionInvoice = true;
    }

    this.checkTotalAttachmentSize(this.invoice.Documents);
    this.getVatList();
    this.setPensionSavingsAmount();
    this.initializePayoutToggleDefaults();

    this.checkCorrectEmailFormat(this.invoice.RecieverEmail, 'RecieverEmail');
    this.checkCorrectEmailFormat(this.invoice.RecieverEmailCopy, 'RecieverEmailCopy');
    this.checkCorrectEmailFormat(this.invoice.RecieverEmailReminder, 'RecieverEmailReminder');


    if (this.showExpressDialog)
      this.expressPayoutClick(true);

    if (this.invoice.DiscountCodes != null) {
      this.invoice.DiscountCodes = this.invoice.DiscountCodes.filter(discount =>
        discount.Code !== 'V\u00e4rvningskod (v\u00e4rvad)' &&
        discount.Code !== 'V\u00e4rvningskod (v\u00e4rvare)'
      );
    }

    this.scrollToWorkedHoursIfRequested();
  }

  private scrollToWorkedHoursIfRequested(): void {
    if (this.route.snapshot.queryParamMap.get('focus') !== 'worked-hours') {
      return;
    }

    setTimeout(() => {
      const element = document.getElementById('worked-hours-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  getReferralText(discount: any): string {
    const categoryText = discount.Category === DiscountCategory.Percentage
      ? `${discount.DiscountPercentage}% rabatt`
      : `${discount.FixedDiscountAmount} kr rabatt`;

    const typeText = discount.Type === DiscountType.ServiceFee
      ? 'serviceavgiften'
      : 'fakturaavgiften';

    return `${categoryText} på ${typeText}`;
  }

  getInvoicePaymentTerm() {

    this.invoice.PaymentTerm = (this.invoice.PaymentTerm == undefined || this.invoice.PaymentTerm == "0") ? "30" : this.invoice.PaymentTerm.toString();

    if (this.invoice.Customer.PaymentTermLocked) {
      this.invoice.PaymentTerm = this.invoice.Customer.PaymentTerm.toString();
    }
  }

  // Gets the duedate for invoice
  getDueDate() {
    this.PaymentTermInt = parseInt(this.invoice.PaymentTerm);
    this.today = new Date();
    this.DueDate = new Date().setDate(this.today.getDate() + this.PaymentTermInt);
  }

  getAllowanceTypeName(id: string) {
    if (id == "1") {
      return "Milersättning";
    }
    else if (id == "2") {
      return "Traktamente inrikes"
    }
    else if (id == "3") {
      return "Traktamente utrikes"
    }
  }

  updateSumNetExpenses() {

    this.sumNetExpenses = 0;

    //Sums all deductions
    for (var i = 0; i < this.invoice.Deductions.length; i++) {
      this.sumNetExpenses += this.invoice.Deductions[i].Amount;
    }

    //Sums all allowances
    for (var i = 0; i < this.invoice.Allowances.length; i++) {
      this.sumNetExpenses += this.invoice.Allowances[i].Sum;
    }
  }

  expressPayoutClick(express: boolean) {

    // // stop the click from unchecking the checkbox
    event.preventDefault();

    if (express && !this.isAdmin && this.isExpressPayoutBlockedByDueDate()) {
      this.updateExpressPayoutStatusUI(this.invoice.ExpressPayOut);
      return;
    }

    if (express && !this.canUseExpressPayout()) {
      this.invoice.ExpressPayOut = false;
      this.ExpressPayoutLocal = false;
      this.updateExpressPayoutStatusUI(false);
      this.showMessage(this.getExpressPayoutEligibilityMessage());
      return;
    }

    // Block enabling express after sent if payment term exceeds 30 days
    if (express) {
      const statusName = (this.invoice && this.invoice.Status && this.invoice.Status.TechnicalName) ? this.invoice.Status.TechnicalName : '';
      const term = parseInt(this.invoice && this.invoice.PaymentTerm ? this.invoice.PaymentTerm : '0', 10);
      if (typeof statusName === 'string' && statusName.startsWith('Sent') && term > 30) {
        this.updateExpressPayoutStatusUI(false);
        this.invoice.ExpressPayOut = false;
        this.showMessage('Fakturan är redan skickad. Express kan bara väljas i efterhand om betalvillkoren är 30 dagar eller lägre.');
        return;
      }
    }

    if (express && this.isAdmin) {
      this.invoice.ExpressPayOut = true;
      this.updateExpressPayoutStatusUI(true);
      this.ExpressPayoutLocal = this.invoice.ExpressPayOut;
      this.loadGlobalServiceFee();
      this.updatePensionSavingsAmount();
      this.sendValidates();
      return;
    }

    if (express) {

      // Personal number and not logged in via BankID
      if (!this.authenticationService.currentUserIsLoggedInWithBankId() && !this.authenticationService.currentUserHasCoordinationNumber()) {

        var currentUserId = this.authenticationService.currentUserUserId();
        var currentUserEmailEncrypted = this.authenticationService.currentUserEmailEncrypted();

        console.log(currentUserEmailEncrypted);

        let dialogRef = this.dialog.open(this.expressBankIdDialog, {
          width: '560px',
          maxWidth: '95vw',
          maxHeight: '90vh',
          panelClass: 'express-payout-dialog-panel'
        });

        dialogRef.afterClosed().subscribe((result: IConfirmResponse) => {
          dialogRef = null;

          if (result?.Confirmed) {
            // If it´s not saved, save a draft so we can return to the page later
            this.saveDraftAndSurpressErrors(this.invoice).subscribe((response) => {

              const invoiceId = typeof response === 'number' ? response : response?.Id;
              if (!Number.isInteger(invoiceId) || invoiceId <= 0) {
                alert('Kunde inte hämta fakturans ID efter sparandet. Försök igen.');
                return;
              }

              this.localStorageService.removeItem("AUTH");
              this.localStorageService.setItem("editInvoice", invoiceId);
              this.localStorageService.setItem("bankIdLoginUserId", currentUserId);
              this.authenticationService.clearLoginStorage();

              var bankIdUrl = this.bankIdUrl + '&email=' + currentUserEmailEncrypted;
              window.location.href = bankIdUrl;

              //window.location.href = "http://localhost:51924?email=" + this.authenticationService.userData.User.EmailEncrypted;


            }, err => alert(err));

          }
        });

      }
      // No personal number or allready logged in
      else {
        // ask for confirmation
        let dialogRef = this.dialog.open(this.expressPayoutDialog, {
          width: '560px',
          maxWidth: 'calc(100vw - 32px)',
          maxHeight: 'calc(100dvh - 32px)',
          panelClass: 'express-payout-dialog-panel'
        });

        dialogRef.afterClosed().subscribe((result: IConfirmResponse) => {
          dialogRef = null;

          if (result?.Confirmed) {
            this.invoice.ExpressPayOut = true;
            this.updateExpressPayoutStatusUI(express);
            this.ExpressPayoutLocal = this.invoice.ExpressPayOut;
            this.loadGlobalServiceFee();
            this.updatePensionSavingsAmount();
            this.sendValidates();
          }
        });
      }

    }
    else {
      this.invoice.ExpressPayOut = false;
      this.ExpressPayoutLocal = this.invoice.ExpressPayOut;
      this.loadGlobalServiceFee();
      this.updatePensionSavingsAmount();
    }
  }

  updateExpressPayoutStatusUI(express: boolean) {
    if (this.rbExpressPayoutYes) {
      this.rbExpressPayoutYes.checked = express;
    }
    if (this.rbExpressPayoutNo) {
      this.rbExpressPayoutNo.checked = !express;
    }
  }

  loadGlobalServiceFee() {
    const express = this.invoice.ExpressPayOut;
    this.invoiceService.getGlobalServiceFee(express)
      .subscribe(
        value => this.onGetGlobalServiceFeeFinished(value),
        error => this.onGetGlobalServiceFeeFinished(error)
      );
  }

  onGetGlobalServiceFeeFinished(serviceFeeFactor: any) {
    if (typeof serviceFeeFactor === 'number' && !isNaN(serviceFeeFactor)) {
      this.serviceFeeFactor = serviceFeeFactor;
      if (this.TotalInvoiceAmount > 0 && (this.pensionSavingsPercent > 0 || this.pensionSavingsAmount > 0 || this.invoice.PensionSavingsFactor > 0)) {
        this.updatePensionSavingsAmount();
      }
      else {
        this.calculatePreliminaryPayout();
      }
    }
  }

  allowOnlyDigits(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  calculatePreliminaryPayout2() {

    var sampoolenFee = 0;
    var invoiceFee = 0;
    this.updateSumNetExpenses();

    //Calculates SAMpoolen-fee    
    const express = this.invoice.ExpressPayOut;
    const fallbackServiceFeeFactor = express ? 0.05 : 0.02;
    const serviceFeeFactor = this.serviceFeeFactor > 0 ? this.serviceFeeFactor : fallbackServiceFeeFactor;
    sampoolenFee = Math.round(this.invoice.TotalInvoiceAmount * serviceFeeFactor);

    //Calculate invoice fee
    if (this.invoice.FeePaidByReciever == false) {
      invoiceFee = 29;
    }

    this.sumFees = sampoolenFee + invoiceFee;
    this.preliminaryPayout = this.invoice.TotalInvoiceAmount - this.sumFees;

  }

  calculatePreliminaryPayout() {
    let invoiceFee = 0;
    this.updateSumNetExpenses();

    const express = this.invoice.ExpressPayOut;
    const fallbackServiceFeeFactor = express ? 0.05 : 0.02;
    const serviceFeeFactor = this.serviceFeeFactor > 0 ? this.serviceFeeFactor : fallbackServiceFeeFactor;

    const totalInvoiceAmount = this.invoice.TotalInvoiceAmount;
    const totalServiceFee = Math.sign(totalInvoiceAmount) * Math.round(Math.abs(totalInvoiceAmount * serviceFeeFactor));

    // Calculate invoice fee
    if (!this.invoice.FeePaidByReciever) {
      invoiceFee = 29;
    }

    this.sumFees = totalServiceFee + invoiceFee;
    this.preliminaryPayout = totalInvoiceAmount - this.sumFees; 

  }

  hasPreliminarySalaryAmount(): boolean {
    return Number(this.TotalInvoiceAmount || this.invoice?.TotalInvoiceAmount || 0) > 0;
  }

  invoiceHasBeenSent(): boolean {
    const status = this.invoice && this.invoice.Status ? this.invoice.Status.TechnicalName : '';
    return !['Draft', 'OfferingRequested', 'OfferingSent', 'JobPreNotification'].includes(status);
  }

  openVatInformationDialog(): void {
    if (!this.vatInformationDialog) {
      return;
    }

    this.dialog.open(this.vatInformationDialog, {
      width: '560px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'vat-information-dialog-panel'
    });
  }

  openPreliminarySalaryDialog(): void {
    if (!this.hasPreliminarySalaryAmount() || this.invoiceHasBeenSent() || !this.preliminarySalaryDialog) {
      return;
    }

    this.preliminarySalaryCalculation = null;
    this.preliminarySalaryError = '';
    this.dialog.open(this.preliminarySalaryDialog, {
      width: '720px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'preliminary-salary-dialog-panel'
    });
    this.loadPreliminarySalaryCalculation();
  }

  async loadPreliminarySalaryCalculation(): Promise<void> {
    if (this.preliminarySalaryLoading || !this.invoiceSender?.Id) {
      return;
    }

    this.preliminarySalaryLoading = true;
    this.preliminarySalaryError = '';

    try {
      this.calculatePreliminaryPayout();
      this.updatePensionSavingsAmount();
      if (this.pensionSavingsFactor > 0 && !this.pensionLimitTaxContext) {
        this.preliminarySalaryCalculation = null;
        this.preliminarySalaryError = 'Pensionen kan inte beräknas innan skatteuppgifterna har hämtats. Försök igen.';
        return;
      }

      const preliminaryDates = this.getPreliminarySalaryCalculationDates();
      const calculationDate = preliminaryDates.payoutDate;
      const userId = this.invoiceSender.Id;
      const pensionAmount = Math.round(Number(this.pensionSavingsAmount || this.invoice.PensionSavingsAmount || 0));
      // Keep pension tax unrounded in the salary budget, as in invoice-summary.
      const pensionTax = pensionAmount * this.pensionSavingsTaxFactor;
      const pensionInclTax = pensionAmount + pensionTax;
      const invoiceFee = !this.invoice.FeePaidByReciever ? 29 : 0;
      const serviceFee = Math.max(0, this.sumFees - invoiceFee);
      const deductions = (this.invoice.Deductions || []).reduce((sum, deduction) => sum + Number(deduction?.Amount || 0), 0);
      const mileage = (this.invoice.Allowances || [])
        .filter(allowance => allowance?.AllowanceType && (allowance.AllowanceType.Id === 1 || allowance.AllowanceType.Id === '1'))
        .reduce((sum, allowance) => sum + Number(allowance?.Sum || 0), 0);
      const allowances = (this.invoice.Allowances || [])
        .filter(allowance => !allowance?.AllowanceType || (allowance.AllowanceType.Id !== 1 && allowance.AllowanceType.Id !== '1'))
        .reduce((sum, allowance) => sum + Number(allowance?.Sum || 0), 0);
      const netExpenses = deductions + allowances + mileage;
      const salaryCost = Math.max(0, this.preliminaryPayout - netExpenses - pensionInclTax);
      const checkZeroTax = this.preliminaryPayout < 1000;

      const [employerTax, employerTaxes, municipalityTax, paidGrossSalary, garnishmentMonth] = await Promise.all([
        this.getPreliminaryCalculationValue(this.userService.getUserEmployerTax(userId, checkZeroTax), this.invoiceSender?.EmployerTax || null),
        this.getPreliminaryCalculationValue(this.employerTaxService.getEmployerTaxes(), []),
        this.getPreliminaryCalculationValue(this.userService.getUserMunicipalityTax(calculationDate, userId, checkZeroTax), Number(this.invoiceSender?.Municipality?.Tax || 0)),
        this.getPreliminaryCalculationValue(this.userService.getUserPayoutGrossSalaryInMonth(userId, calculationDate), { grossSalary: 0 }),
        this.getPreliminaryCalculationValue(this.userService.getUserWageGarnishmentsForCurrentMonth(userId, calculationDate), { wageGarnishmentAmount: 0, netPaidThisMonth: 0 })
      ]);

      const grossSalary = this.calculatePreliminaryGrossSalary(
        salaryCost,
        employerTax,
        employerTaxes || [],
        Number(paidGrossSalary?.grossSalary || 0)
      );
      const employerTaxAmount = Math.max(0, Math.round(salaryCost) - Math.round(grossSalary));
      const municipalityTaxAmount = Math.max(0, grossSalary * Number(municipalityTax || 0));
      const netSalaryBeforeGarnishment = Math.max(0, grossSalary - municipalityTaxAmount);
      const activeGarnishment = this.getActivePreliminaryGarnishment(calculationDate);
      const wageGarnishment = this.calculatePreliminaryGarnishment(
        activeGarnishment,
        netSalaryBeforeGarnishment,
        0,
        Number(garnishmentMonth?.wageGarnishmentAmount || 0),
        Number(garnishmentMonth?.netPaidThisMonth || 0)
      );
      const totalPayout = Math.max(0, netSalaryBeforeGarnishment + netExpenses - wageGarnishment);
      const netSalaryPayout = Math.max(0, netSalaryBeforeGarnishment - wageGarnishment);

      this.preliminarySalaryCalculation = {
        calculationDate,
        calculationDateText: calculationDate.toLocaleDateString('sv-SE'),
        dueDateText: preliminaryDates.dueDate.toLocaleDateString('sv-SE'),
        isExpressPayout: preliminaryDates.isExpress,
        hasWageGarnishment: !!activeGarnishment,
        invoiceAmount: Math.round(Number(this.invoice.TotalInvoiceAmount || 0)),
        serviceFeeRate: Number(this.invoice.TotalInvoiceAmount || 0) > 0 ? (serviceFee / Number(this.invoice.TotalInvoiceAmount)) * 100 : 0,
        serviceFee,
        invoiceFee: Math.round(invoiceFee),
        employerTaxRate: Number(employerTax?.Tax || 0) * 100,
        employerTaxAmount: Math.round(employerTaxAmount),
        municipalityTaxRate: Number(municipalityTax || 0) * 100,
        municipalityTaxAmount: Math.round(municipalityTaxAmount),
        grossSalary: Math.round(grossSalary),
        vacationPay: Math.round(grossSalary * 0.12 / 1.12),
        netSalary: Math.round(netSalaryBeforeGarnishment),
        netExpenses: Math.round(netExpenses),
        deductions: Math.round(deductions),
        allowances: Math.round(allowances),
        mileage: Math.round(mileage),
        salaryBasis: Math.round(salaryCost),
        pensionAmount,
        pensionTax: Math.round(pensionTax),
        pensionInclTax: Math.round(pensionInclTax),
        wageGarnishment: Math.round(wageGarnishment),
        netSalaryPayout: Math.round(netSalaryPayout),
        totalPayout: Math.round(totalPayout)
      };
    } catch (error) {
      console.error('Kunde inte beräkna preliminär löneutbetalning.', error);
      this.preliminarySalaryCalculation = null;
      this.preliminarySalaryError = 'Den preliminära löneberäkningen kunde inte hämtas. Försök igen.';
    } finally {
      setTimeout(() => {
        this.preliminarySalaryLoading = false;
        this.cdr.detectChanges();
      }, 0);
    }
  }

  private getPreliminarySalaryCalculationDates(): { dueDate: Date, payoutDate: Date, isExpress: boolean } {
    const today = new Date();
    const paymentTerm = Number(this.invoice.PaymentTerm || 0);
    const dueDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + paymentTerm);
    const isExpress = this.invoice.ExpressPayOut === true;
    const payoutBaseDate = isExpress
      ? new Date(today.getFullYear(), today.getMonth(), today.getDate())
      : dueDate;

    return {
      dueDate,
      payoutDate: this.getNextWeekday(payoutBaseDate),
      isExpress
    };
  }

  private getNextWeekday(date: Date): Date {
    const nextDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    while (nextDate.getDay() === 0 || nextDate.getDay() === 6) {
      nextDate.setDate(nextDate.getDate() + 1);
    }
    return nextDate;
  }

  private getPreliminaryCalculationValue<T>(request: Observable<T>, fallback: T): Promise<T> {
    return firstValueFrom(
      request.pipe(
        timeout(5000),
        catchError(error => {
          console.warn('Ett underlag till den preliminära löneberäkningen kunde inte hämtas.', error);
          return of(fallback);
        })
      )
    );
  }

  private calculatePreliminaryGrossSalary(salaryCost: number, selectedTax: any, employerTaxes: any[], paidGrossSalary: number): number {
    if (!selectedTax || salaryCost <= 0) {
      return 0;
    }

    if (selectedTax.Name !== 'TempYouth') {
      return salaryCost / (1 + Number(selectedTax.Tax || 0));
    }

    const normalTax = employerTaxes.find(tax => tax?.Name === 'Normal' && (!selectedTax.Year || tax.Year === selectedTax.Year));
    if (!normalTax) {
      return salaryCost / (1 + Number(selectedTax.Tax || 0));
    }

    const remainingReducedGrossSalary = Math.max(0, 25000 - paidGrossSalary);
    const reducedCostLimit = remainingReducedGrossSalary * (1 + Number(selectedTax.Tax || 0));
    if (salaryCost <= reducedCostLimit) {
      return salaryCost / (1 + Number(selectedTax.Tax || 0));
    }

    return remainingReducedGrossSalary + ((salaryCost - reducedCostLimit) / (1 + Number(normalTax.Tax || 0)));
  }

  private getActivePreliminaryGarnishment(calculationDate: Date): any {
    const compareDate = new Date(calculationDate);
    compareDate.setHours(0, 0, 0, 0);

    return (this.invoiceSender?.AttachmentOfSalaries || [])
      .filter(garnishment => {
        const startDate = new Date(garnishment?.DateStart);
        const endDate = new Date(garnishment?.DateEnd);
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          return false;
        }
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        return startDate <= compareDate && endDate >= compareDate;
      })
      .sort((a, b) => Number(b?.Id || 0) - Number(a?.Id || 0))[0] || null;
  }

  private calculatePreliminaryGarnishment(garnishment: any, netSalary: number, garnishableExpenses: number, deductedThisMonth: number, netPaidThisMonth: number): number {
    if (!garnishment) {
      return 0;
    }

    const remainingAttachment = Math.max(0, Number(garnishment.AttachmentAmount || 0) - deductedThisMonth);
    const protectedAmount = Math.max(0, Number(garnishment.ReservedAmount || 0) - netPaidThisMonth);
    const possibleToDeduct = Math.max(0, netSalary + garnishableExpenses - protectedAmount);
    return Math.min(possibleToDeduct, remainingAttachment);
  }

  //Used for saving draft when asking for BankID login
  saveDraftAndSurpressErrors(invoice: any) {
    this.calculatePreliminaryPayout();
    this.reseTmpIds();

    if (!this.canUpdateGeneral()) {
      return this.invoiceService.updateInvoice(invoice, 'Fakturan uppdaterad!', undefined);
    }
    else if (this.canUpdateInvoiceDraft()) {

      if (this.invoice.Status == null) {
        invoice.Status = { Name: 'Utkast' };
      }

      if (invoice.Id == undefined || invoice.Id == 0) {
        return this.invoiceService.createInvoice(invoice, 'Fakturan skapad!', undefined);
      }
      else {
        return this.invoiceService.updateInvoice(invoice, 'Fakturan uppdaterad!', undefined);
      }

    }
    else {
      alert('Ett ohanterat fel inträffade, vänligen kontakta support!');
    }

  }

  fileChange(event: any, file: any) {

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let f: File = fileList[0];

      if (f.size > 5242880) {
        alert('Max 5 Mb per fil!')
        // Rensa filinmatningen så filnamnet inte visas kvar
        if (event && event.target) {
          try { event.target.value = null; } catch { /* ignore */ }
        }
        return false;
      }

      this.invoiceService.uploadDocument(f, file.Attachment.Guid)
        .subscribe(
          response => this.onDocumentSaved(response, file.Attachment.Guid),
          error => console.log(error));

    }
  }

  uploadAddFile(event: any, file: any) {

    if (event.target.files.length > 0) {

      let fileList: FileList = event.target.files;
      let f: File = fileList[0];

      if (f.size > 5242880) {
        alert('Filen är för stor, max 5 Mb')
        // Rensa filinmatningen så filnamnet inte visas kvar
        if (event && event.target) {
          try { event.target.value = null; } catch { /* ignore */ }
        }
        return false;
      }

      if (Array.isArray(file)) {

        var newFile = { Guid: this.newGuid(), Name: f.name };
        file.push(newFile);

        this.invoiceService.uploadDocument(f, newFile.Guid)
          .subscribe(
            response => this.fileUploaded(response, newFile),
            error => console.log(error));

      }
      else {
        if (file.Guid == undefined) {
          file.Guid = this.newGuid();
        }

        this.invoiceService.uploadDocument(f, file.Guid)
          .subscribe(
            response => this.fileUploaded(response, file),
            error => console.log(error));

      }

    }
  }

  fileUploaded(response: any, file: any) {
    file.Guid = response.Guid;
    file.Url = response.Url;
  }

  deleteReciept(guid: string) {

    for (var i = 0; i < this.invoice.TravelExpenses.Reciepts.length; i++) {
      if (this.invoice.TravelExpenses.Reciepts[i].Guid == guid)
        this.invoice.TravelExpenses.Reciepts.splice(i, 1);
    }
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  showDocument(url: string) {
    console.log(url);

    window.open(url);
  }

  editDeduction(sender, deduction: IDeduction) {
    if (this.isInvoiceContentLocked()) return;

    const invoiceCurrencyName = (this.invoice && this.invoice.Currency && this.invoice.Currency.Name) ? this.invoice.Currency.Name : null;
    const currencyIsSek = (invoiceCurrencyName == null) ? true : invoiceCurrencyName.toUpperCase() === 'SEK';

    if (deduction != null) {
      this.config.data.deduction = deduction;

      if (this.config.data.deduction.AttachmentReciept == null)
        this.config.data.deduction.AttachmentReciept = <IFile>{ Id: 0, Guid: null }

      if (this.config.data.deduction.Attachment == null)
        this.config.data.deduction.Attachment = <IFile>{ Id: 0, Guid: null }
    }
    else {
      this.config.data.deduction = { Id: this.newGuid(), Attachment: <IFile>{ Id: 0, Guid: null }, AttachmentReciept: <IFile>{ Id: 0, Guid: null }, VatPercentage: '25', TravelExpense: false, AddedToInvoice: false } as IDeduction;


      if (sender == "addedToInvoice" && currencyIsSek) {
        this.config.data.deduction.AddedToInvoice = true;
      }
    }

    // Ensure userId is provided to the dialog in all cases
    try {
      let userId: any = null;
      if (this.invoice && this.invoice.UserSettings && this.invoice.UserSettings.Id) {
        userId = this.invoice.UserSettings.Id;
      } else if (this.invoiceSender && this.invoiceSender.Id) {
        userId = this.invoiceSender.Id;
      } else if (this.invoice && this.invoice.User && this.invoice.User.Id) {
        userId = this.invoice.User.Id;
      }
      this.config.data.userId = userId;
    } catch { /* ignore */ }

    this.config.data.status = this.invoice.Status;
    this.config.data.invoiceCurrencyName = invoiceCurrencyName;
    let dialogRef = this.dialog.open(EditDeductionDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: IDeduction) => {
      if (result == null) {
        dialogRef = null;
        return;
      }

      // Defer updates to avoid ExpressionChangedAfterItHasBeenCheckedError on close.
      setTimeout(() => {
        for (var i = 0; i < this.invoice.Deductions.length; i++) {
          var d = this.invoice.Deductions[i];

          if (d.Id == result.Id) {
            this.invoice.Deductions[i] = result;
            this.openPayoutToggleForBilledDeduction(result);
            this.updateTotalInvoiceAmount();
            this.invoice.Deductions = [...this.invoice.Deductions];
            this.cdr.detectChanges();
            dialogRef = null;
            return;
          }
        }

        this.invoice.Deductions.push(result);
        this.openPayoutToggleForBilledDeduction(result);
        this.updateTotalInvoiceAmount();
        this.invoice.Deductions = [...this.invoice.Deductions];
        this.cdr.detectChanges();
        dialogRef = null;
      }, 0);
    });
  }

  deleteDeduction(deduction: any) {
    if (this.isInvoiceContentLocked()) return;

    for (var i = 0; i < this.invoice.Deductions.length; i++) {
      var d = this.invoice.Deductions[i];

      if (d.Attachment.Guid == deduction.Attachment.Guid) {
        this.invoice.Deductions.splice(i, 1);
        this.updateTotalInvoiceAmount();
        return;
      }

    }

    this.updateSumNetExpenses();
  }

  generateTemporaryId(): number {
    return -Math.floor(Math.random() * 1000000); // Generates a unique negative number
  }

  editAllowance(sender, allowance: IAllowance) {
    if (this.isInvoiceContentLocked()) return;

    const invoiceCurrencyName = (this.invoice && this.invoice.Currency && this.invoice.Currency.Name) ? this.invoice.Currency.Name : null;
    const currencyIsSek = (invoiceCurrencyName == null) ? true : invoiceCurrencyName.toUpperCase() === 'SEK';

    if (allowance != null) {

      this.config.data.allowance = allowance;

      if (this.config.data.allowance.AttachmentReciept == null)
        this.config.data.allowance.AttachmentReciept = <IFile>{ Id: 0, Guid: null }

      if (this.config.data.allowance.Attachment == null)
        this.config.data.allowance.Attachment = <IFile>{ Id: 0, Guid: null }
    }
    else {
      this.config.data.allowance = { Id: this.generateTemporaryId(), Attachment: <IFile>{ Id: 0, Guid: null }, AttachmentReciept: <IFile>{ Id: 0, Guid: null }, VatPercentage: '25' } as IAllowance;

      if (sender == "addedToInvoice" && currencyIsSek) {
        this.config.data.allowance.AddedToInvoice = true;
      }
    }

    this.config.data.status = this.invoice.Status;
    this.config.data.invoiceCurrencyName = invoiceCurrencyName;
    let dialogRef = this.dialog.open(EditAllowanceDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: IAllowance) => {
      if (result == null) {
        dialogRef = null;
        return;
      }

      // Defer updates to avoid ExpressionChangedAfterItHasBeenCheckedError on close.
      setTimeout(() => {
        for (var i = 0; i < this.invoice.Allowances.length; i++) {
          var d = this.invoice.Allowances[i];

          if (d.Id == result.Id) {
            this.invoice.Allowances[i] = result;
            this.openPayoutToggleForBilledAllowance(result);
            // Recalculate totals and expenses when editing an existing allowance
            this.updateSumNetExpenses();
            this.updateTotalInvoiceAmount();
            this.invoice.Allowances = [...this.invoice.Allowances];
            this.cdr.detectChanges();
            dialogRef = null;
            return;
          }
        }

        if (result.CustomReimbursementPerKm > 0) {

        }

        this.invoice.Allowances.push(result);
        this.openPayoutToggleForBilledAllowance(result);
        this.updateSumNetExpenses();
        this.updateTotalInvoiceAmount();
        this.invoice.Allowances = [...this.invoice.Allowances];
        this.cdr.detectChanges();
        dialogRef = null;
      }, 0);
    });
  }

  copyMileageAllowance(sender: string, allowance: IAllowance): void {
    if (!allowance || !allowance.AllowanceType || String(allowance.AllowanceType.Id) !== '1') {
      return;
    }

    const copy = JSON.parse(JSON.stringify(allowance)) as IAllowance;
    copy.Id = this.generateTemporaryId();
    copy.TravelDateStart = null;
    copy.TravelDateEnd = null;
    copy.TotalCarMileage = null;

    this.editAllowance(sender, copy);
  }

  deleteAllowance(allowance: any) {
    if (this.isInvoiceContentLocked()) return;
    for (var i = 0; i < this.invoice.Allowances.length; i++) {
      var a = this.invoice.Allowances[i];

      if (a.Id == allowance.Id) {
        this.invoice.Allowances.splice(i, 1);
        this.updateSumNetExpenses();
        this.updateTotalInvoiceAmount();
        return;
      }

      this.updateSumNetExpenses();
      this.updateTotalInvoiceAmount();

    }
  }

  onDocumentSaved(attachment: any, originalGuid?: string) {
    for (var i = 0; i < this.invoice.Deductions.length; i++) {
      var doc = this.invoice.Deductions[i];

      if (doc.Attachment.Guid == attachment.Guid || (originalGuid != null && doc.Attachment.Guid == originalGuid)) {
        doc.Attachment.Guid = attachment.Guid;
        doc.Attachment.Url = attachment.Url;
        if (attachment.FileType) {
          doc.Attachment.FileType.Id = attachment.FileType.Id;
        }
      }
    }

  }

  clearErrorMessage(type: string) {
    if (type === 'RecieverEmail') {
      this.ErrorMessageRecieverEmail = '';
    } else if (type === 'RecieverEmailCopy') {
      this.ErrorMessageRecieverCopyEmail = '';
    } else if (type === 'RecieverEmailReminder') {
      this.ErrorMessageRecieverReminderEmail = '';
    }
  }

  sendValidates(allowMissingUserInformation: boolean = false) {

    if (!this.isLoading) {
      if (!this.validateFixedPensionAmount() || !this.validatePensionLimit()) return false;

      if (this.hasDuplicateInvoiceEmails) {
        this.ErrorMessageSend = 'Kopiemottagare får inte upprepas. Fakturans mottagaradress får inte användas för kopia eller påminnelse. Se punkt 3.';
        this.sendInvoiceValidates = false;
        return false;
      }

      if (this.invoice.CreditInvoiceFor != null) {
        this.ErrorMessageSend = '';
        this.errorMessageFiles = '';
        this.sendInvoiceValidates = true;
        return true;
      }
            
      if (this.invoiceSender != undefined && this.invoiceSender.Suspended) {
        this.ErrorMessageSend = 'Ditt konto är spärrat';
        this.sendInvoiceValidates = false;
        return false;
      }

      this.validatePensionSavingsCompany();

      if (this.requiresPensionSavingsCompany() && this.invoice.CreditInvoiceFor == null) {
        this.ErrorMessageSend = this.errorMessagePensionSavingsCompany;
        this.sendInvoiceValidates = false;
        return false;
      }

      if (!this.validateTotalShareSalary()) {
        this.ErrorMessageSend = this.getSalaryShareValidationErrorMessage();
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (!this.validateTimeReportingChoice()) {
        return false;
      }

      //You can only send if the status is Draft or an offering
      else if (this.invoice.Status.TechnicalName != "Draft" && this.invoice.Status.TechnicalName != "OfferingRequested" && this.invoice.Status.TechnicalName != "OfferingSent" && this.invoice.Status.TechnicalName != "JobPreNotification") {
        this.ErrorMessageSend = 'Den här fakturan har skickats';
        this.sendInvoiceValidates = false;
        return false;
      }

      //Customer is mandatory 
      else if (!this.invoice.Customer.Id) {
        this.ErrorMessageSend = 'Du behöver lägga till en kund';
        return false;
      }

      if (!this.invoice.Customer.Active && this.isAdmin) {
        this.ErrorMessageSend = 'Kundföretaget är inaktivt, faktura kan ej skickas av medlem.';
      }
      else if (this.invoice.Customer.Id > 0 && !this.invoice.Customer.Active) {
        this.ErrorMessageSend = 'Kundföretaget är inaktivt, faktura kan ej skickas.';
        this.sendInvoiceValidates = false;
        return false;
      }

      //Customer needs to have the active status 
      else if (!this.invoice.Customer.Active && !this.isAdmin) {
        this.ErrorMessageSend = 'Du kan inte använda kund med detta organisationsnummer. Kontakta SAMpoolen vid frågor.';
      }

      //Customer reference is mandatory
      else if (this.invoice.Customer.IsCompany && !this.invoice.Reference?.Id) {
        this.ErrorMessageSend = 'Du behöver lägga till en kontaktperson till din kund';
        this.sendInvoiceValidates = false;
        return false;
      }

      //Only credit invoices can be 0 or less
      else if ((this.invoice.TotalInvoiceAmount <= 0 || this.TotalInvoiceAmount <= 0) && this.invoice.CreditInvoiceFor == null) {
        this.ErrorMessageSend = 'Du måste fakturera mer än 0 kr i punkt nr 2';
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.hasBillableExpensesInForeignCurrency()) {
        this.ErrorMessageSend = this.getForeignCurrencyBillableExpensesErrorMessage();
        this.sendInvoiceValidates = false;
        return false;
      }

      //Total filesize maximum is 15Mb
      else if (this.totalFileSize > 15728640) {
        this.ErrorMessageSend = "Dina bifogade filer får inte överstiga 15Mb tillsammans";
        this.errorMessageFiles = "Dina bifogade filer får inte överstiga 15Mb tillsammans";
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.attachedFilesCount > 5) {
        this.ErrorMessageSend = "Du får bifoga högst 5 st dokument";
        this.errorMessageFiles = "Du får bifoga högst 5 st dokument";
        this.sendInvoiceValidates = false;
        return false;
      }

      //You need an invoice send type
      else if (this.invoice.InvoiceSendType == 0) {
        this.ErrorMessageSend = 'Du har inte angivit någon leveransmetod för din faktura, se punkt 3';
        this.sendInvoiceValidates = false;
        return false;
      }

      //You need a reciever email if sendtype is by email
      else if (this.invoice.InvoiceSendType == 1 && !this.invoice.RecieverEmail) {
        this.ErrorMessageSend = 'Du har valt e-post som leveranssätt, men mottagaren saknar e-postadress';
        this.sendInvoiceValidates = false;
        return false;
      }

      //If EDI/e-faktura is chosen, email address for reminderis is required
      else if (this.invoice.InvoiceSendType == 3 && !this.invoice.RecieverEmailReminder) {
        this.ErrorMessageSend = 'Du har valt EDI (e-faktura) som leveranssätt, e-post för eventuella påminnelser är obligatoriskt';
        this.sendInvoiceValidates = false;
        return false;
      }

      // If EDI/e-faktura is chosen, invoice attachments are not allowed
      else if (this.invoice.InvoiceSendType == 3 && this.attachedFilesCount > 0) {
        this.ErrorMessageSend = 'Du har valt EDI (e-faktura) som leveranssätt. Det går inte att bifoga fakturabilagor för detta leveranssätt. Ta bort bilagorna eller ändra leveranssätt.';
        this.errorMessageFiles = this.ErrorMessageSend;
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.invoice.RecieverEmail != '' && this.recieverEmailValid == false) {
        this.ErrorMessageSend = 'Fakturamottagarens epost har fel format';
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.invoice.RecieverEmailCopy != '' && this.recieverEmailCopyValid == false) {
        this.ErrorMessageSend = 'Epost-adress till mottagare av fakturakopia har fel format';
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.invoice.RecieverEmailReminder != '' && this.recieverEmailReminderValid == false) {
        this.ErrorMessageSend = 'Epost för påminnelser har fel format';
        this.sendInvoiceValidates = false;
        return false;
      }

      // If RUT/ROT is selected, require detailed time on time-reported groups
      else if (this.invoice.IsRut || this.invoice.IsRot) {
        const timeGroups = (this.invoice.InvoiceGroups || []).filter(g => g && g.TimeReportStatus && g.TimeReportStatus.Name && g.TimeReportStatus.Name !== 'NoInfo');

        if (timeGroups.length === 0) {
          this.ErrorMessageSend = 'Vid RUT/ROT krävs att du anger arbetad tid';
          this.sendInvoiceValidates = false;
          return false;
        }

        const hasOnlyDetailed = timeGroups.every(g => g.TimeReportStatus.Name === 'DetailedInfo');
        if (!hasOnlyDetailed) {
          this.ErrorMessageSend = 'Du behöver ange detaljerad tid på fakturor som är RUT/ROT.';
          this.sendInvoiceValidates = false;
          return false;
        }

        //If ROT, you need a property
        if (this.invoice.IsRot) {
          const rotProperty = (this.invoice.RotProperty || '').trim();
          if (!rotProperty) {
            this.ErrorMessageSend = 'När du valt ROT behöver du ange fastighet/lägenhetsnummer.';
            this.sendInvoiceValidates = false;
            return false;
          }
        }
      }

      //If ROT you need to add km to invoice
      //else if (this.invoice.IsRot && this.invoice.RotDrivingFeeKm < 1) {
      //  this.ErrorMessageSend = 'När du valt ROT behöver du ange framkörningssträckan';
      //  this.sendInvoiceValidates = false;
      //  return false;
      //}

      //If electronic reference is mandatory it needs to be filled out
      else if ((!this.invoice.ReferenceText && this.invoice.Customer.ElectronicReferenceMandatory) && !this.isAdmin) {
        this.ErrorMessageSend = 'Din kund kräver en elektronisk referens, se punkt 3';
        this.sendInvoiceValidates = false;
        return false;
      }

      //Pension can't be higher than preliminary payout
      else if (!this.pensionValidates && this.invoice.CreditInvoiceFor == null) {
        this.ErrorMessageSend = this.errorMessagePensionSavingsCompany || 'Du har gjort en för hög avsättning till pension';
        this.sendInvoiceValidates = false;
        return false;
      }

      if (this.ErrorMessageRecieverCopyEmail != '' || this.ErrorMessageRecieverReminderEmail != '' || this.ErrorMessageRecieverEmail != '') {
        this.ErrorMessageSend = 'En mottagaradress under punkt 3. Fakturering har fel format';
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.checkDeductionAttachments() == false) {
        this.ErrorMessageSend = 'Ett avdrag saknar uppladdat kvitto';
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (!this.isAdmin && !allowMissingUserInformation &&
        (this.userPhoneNumberNeedsUpdate || this.userEmailNeedsUpdate || this.userPersonalNumberNeedsUpdate ||
          this.bankInfoNeedsUpdate ||
          !this.invoiceSenderBankDetailsAreValid(false))
      ) {
        this.ErrorMessageSend = 'Vi saknar information om dig för att kunna skicka fakturan och betala ut din lön. <br/> Högst upp på sidan kan du lägga till dina uppgifter.';
        this.sendInvoiceValidates = false;
        return false;
      }

      //Terms of use must be checked
      else if (!this.invoice.termsAgreed && !this.isAdmin) {
        this.ErrorMessageSend = 'Du måste godkänna användarvillkoren';
        this.sendInvoiceValidates = false;
        return false;
      }

      // Express requires payment terms <= 30 days
      else if (this.invoice.ExpressPayOut && parseInt(this.invoice.PaymentTerm ? this.invoice.PaymentTerm : '0', 10) > 30) {
        this.ErrorMessageSend = 'Vid expressutbetalning får betalvillkoren inte överstiga 30 dagar. Ändra betalvillkor till 30 dagar.';
        this.sendInvoiceValidates = false;
        return false;
      }

      else if (this.isAdmin) {
        this.ErrorMessageSend = '';
        this.errorMessageFiles = '';
        this.sendInvoiceValidates = true;
        return true;
      }

      else {
        this.ErrorMessageSend = '';
        this.errorMessageFiles = '';
        this.sendInvoiceValidates = true;
        return true;
      }
    }
  }

  handleSendClick(invoice: any): void {

    if (this.isLoading) {
      return; // always skip if loading
    }

    if (!this.sendValidates(true)) {
      alert(this.ErrorMessageSend);
      return;
    }

    if (!this.canUpdateInvoice()) {
      return; // silently skip if user is not allowed to update
    }

    if (this.stopIfDuplicateWorkedHoursGroups()) {
      return;
    }

    this.send(invoice, true);
  }


  checkDeductionAttachments() {
    for (var i = 0; i < this.invoice.Deductions.length; i++) {
      if (!this.invoice.Deductions[i].Attachment?.Guid) {
        return false;
      }
    }

    return true;
  }

  personalOrCompanyNumberValid(personalNumber: string, salaryShare: any = null) {
    const normalizedPersonalNumber = this.normalizeSalarySharePersonalNumber(personalNumber);
    const valid = normalizedPersonalNumber.length == 12;

    this.personalOrOrgNumberValid = valid;

    if (salaryShare != null) {
      salaryShare.SearchAccountValid = valid;
      salaryShare.SearchAccountPersonalNumber = normalizedPersonalNumber;
    }

    return this.personalOrOrgNumberValid;
  }

  normalizeSalarySharePersonalNumber(personalNumber: string): string {
    const value: string = personalNumber || '';
    const digits = value.replace(/\D/g, '');

    if (digits.length == 12) {
      return digits;
    }

    if (digits.length == 10) {
      const birthYear = parseInt(digits.substring(0, 2), 10);
      const currentYear = parseInt(new Date().getFullYear().toString().substring(2), 10);
      const century = birthYear <= currentYear ? '20' : '19';
      return century + digits;
    }

    return '';
  }

  onDraftSaved(response: any, createOffering: boolean = false) {

    if (response == null) {
      this.isLoading = false;
      this.showInvoiceSaveError(undefined, createOffering);
      return;
    }

    if (createOffering) {
      alert("Tack för din offertbegäran! Vi kommer nu granska innehållet, och du får den färdiga offerten som pdf till din epost senast nästa arbetsdag");
    }

    if (this.appId == 1) {
      this.router.navigate(['/mypages/invoices']);
    }
    if (this.appId == 2) {
      this.router.navigate(['/organization/invoices']);
    }

  }

  isInvoiceContentLocked(): boolean {
    return ['Paired', 'Credited'].includes(this.invoice?.Status?.TechnicalName);
  }

  canUpdateInvoice() {
    if (this.isInvoiceContentLocked()) return false;
    // You have to be able to save payout information until it's been paid out
    let statuses = ["Draft", "UnderReview", "SentUnpaid", "SentReminder", "SentCollection", "SentBailiff", "OfferingRequested", "ExpressInquirySent", "OfferingSent", "JobPreNotification"];

    if (this.isAdmin) {
      return !this.isLoading && !this.requiresPensionSavingsCompany();
    }
    else {
      return this.isLoading == false &&
        this.invoice.Customer.Id > 0 &&
        (this.TotalInvoiceAmount >= 0 || (this.TotalInvoiceAmount < 0 && this.invoice.CreditInvoiceFor != null)) &&
        this.invoice.termsAgreed &&
        this.referenceValidates() &&
        statuses.includes(this.invoice.Status.TechnicalName)
    }
  }

  canUpdateInvoiceDraft() {
    if (this.isInvoiceContentLocked()) return false;

    let statuses = ["Draft", "UnderReview", "SentUnpaid", "ExpressInquirySent", "SentReminder", "SentCollection", "SentBailiff", "JobPreNotification", "OfferingRequested", "OfferingSent"];

    if (this.isAdmin) {
      return true;
    }
    else {
      return this.isLoading == false &&
        //this.invoice.Customer.Id > 0 &&
        //this.TotalInvoiceAmount > 0 &&
        //this.referenceValidates() &&
        !this.requiresPensionSavingsCompany() &&
        statuses.includes(this.invoice.Status.TechnicalName)
    }
  }

  canUpdatePayout() {
    if (this.isInvoiceContentLocked()) return false;
    let statuses = ["Draft", "UnderReview", "SentUnpaid", "ExpressInquirySent", "SentReminder", "SentCollection", "SentBailiff", "JobPreNotification"];

    if (this.isAdmin) {
      return true;
    }
    else {
      return statuses.includes(this.invoice.Status.TechnicalName)
    }
  }

  canUpdateGeneral() {
    if (this.isInvoiceContentLocked()) return false;

    if (this.isAdmin) {
      return true && !this.isLoading;
    }
    else {
      let statuses = ["Draft", "OfferingRequested", "OfferingSent", "JobPreNotification"];

      if (this.invoice.CreditInvoiceFor != null) {
        return false;
      }
      else {
        return !this.isLoading && statuses.includes(this.invoice.Status.TechnicalName)
      }
    }
  }

  canEditWorkedHoursGroup() {
    if (this.isInvoiceContentLocked()) return false;
    if (this.isAdmin) {
      return !this.isLoading;
    }

    return !this.isLoading && !this.hasBlockingEmployerCertificateRequest();
  }

  hasBlockingEmployerCertificateRequest(): boolean {
    const invoice: any = this.invoice || {};
    return !!(invoice.HasBlockingEmployerCertificateRequest ?? invoice.hasBlockingEmployerCertificateRequest);
  }

  isSubInvoice(): boolean {
    return this.invoice?.SubInvoice === true || this.invoice?.Type?.TechnicalName === 'SubInvoice';
  }

  isWorkedHoursGroup(group: any): boolean {
    if (!group || this.isSubInvoice()) {
      return false;
    }

    const tech = group.Type && group.Type.TechnicalName ? String(group.Type.TechnicalName) : '';
    if (tech === this.workedHoursGroupType) {
      return true;
    }

    const name = group.Type && group.Type.Name ? String(group.Type.Name).toLowerCase() : '';
    if (name === 'arbetad tid') {
      return true;
    }

    const hasExplicitType = group.Type != null && (
      (group.Type.Id != null && String(group.Type.Id).trim() !== '')
      || (group.Type.Value != null && String(group.Type.Value).trim() !== '')
      || tech.trim() !== ''
      || name.trim() !== ''
    );
    if (hasExplicitType) {
      return false;
    }

    const description = typeof group.Description === 'string' ? group.Description.trim().toLowerCase() : '';
    if (description === 'arbetad tid') {
      return true;
    }

    return Array.isArray(group.InvoiceRows) && group.InvoiceRows.length > 0;
  }

  isInvoiceItemGroup(group: any): boolean {
    if (!group) {
      return false;
    }

    const tech = group.Type && group.Type.TechnicalName ? String(group.Type.TechnicalName) : '';
    if (tech === this.invoiceItemGroupType) {
      return true;
    }

    const name = group.Type && group.Type.Name ? String(group.Type.Name).toLowerCase() : '';
    return name === this.invoiceItemGroupType.toLowerCase();
  }

  private hasLegacyTimeData(group: any): boolean {
    return Array.isArray(group?.InvoiceRows) && group.InvoiceRows.length > 0;
  }

  usesLegacyInvoiceGroupMode(): boolean {
    // Sub-invoice objects keep their descriptions and certificate data without a group type.
    if (this.isSubInvoice()) {
      return true;
    }

    const groups = Array.isArray(this.invoice?.InvoiceGroups) ? this.invoice.InvoiceGroups : [];
    if (groups.length === 0) {
      return false;
    }

    const missingTypeGroups = groups.filter(group => {
      const technicalName = group?.Type?.TechnicalName;
      return typeof technicalName !== 'string' || technicalName.trim() === '';
    });

    if (missingTypeGroups.length > 0) {
      return missingTypeGroups.some(group => this.hasLegacyTimeData(group));
    }

    return this.getWorkedHoursGroups().length > 1;
  }

  getDisplayedInvoiceGroups(): any[] {
    const groups = Array.isArray(this.invoice?.InvoiceGroups) ? this.invoice.InvoiceGroups : [];
    if (this.usesLegacyInvoiceGroupMode()) {
      return groups;
    }

    return groups.filter(group => !this.isWorkedHoursGroup(group));
  }

  getWorkedHoursGroups(): any[] {
    const groups = Array.isArray(this.invoice?.InvoiceGroups) ? this.invoice.InvoiceGroups : [];
    return groups.filter(group => this.isWorkedHoursGroup(group));
  }

  getWorkedHoursInvoiceGroup(): any | null {
    const groups = this.getWorkedHoursGroups();
    return groups.length > 0 ? groups[0] : null;
  }

  private enforceSingleWorkedHoursGroup(showWarning: boolean = false, preferredId?: any): boolean {
    if (this.usesLegacyInvoiceGroupMode() || !Array.isArray(this.invoice?.InvoiceGroups)) {
      return false;
    }

    const workedHoursGroups = this.invoice.InvoiceGroups.filter(group => this.isWorkedHoursGroup(group));
    if (workedHoursGroups.length <= 1) {
      return false;
    }

    const groupToKeep = workedHoursGroups.find(group => group.Id === preferredId) || workedHoursGroups[0];
    this.invoice.InvoiceGroups = this.invoice.InvoiceGroups.filter(group =>
      !this.isWorkedHoursGroup(group) || group === groupToKeep
    );

    if (showWarning) {
      this.showDuplicateWorkedHoursWarning('Det finns redan en grupp för Arbetad tid. Ändringarna sparas på den befintliga gruppen.');
    }

    return true;
  }

  private showDuplicateWorkedHoursWarning(message: string): void {
    this.snackBar.open(message, undefined, {
      duration: 7000,
      panelClass: ['invoice-tool-warning-snackbar']
    });
    this.sendInvoiceValidates = false;
    this.showValidationSummary = true;
  }

  private hasDuplicateWorkedHoursGroups(): boolean {
    return this.getWorkedHoursGroups().length > 1;
  }

  private stopIfDuplicateWorkedHoursGroups(): boolean {
    if (!this.hasDuplicateWorkedHoursGroups()) {
      return false;
    }

    this.showDuplicateWorkedHoursWarning('Det finns fler än en ruta för Arbetad tid. Ta bort dubbletten innan du sparar eller skickar fakturan.');
    return true;
  }

  hasReportedWorkDate(): boolean {
    const groups = this.usesLegacyInvoiceGroupMode()
      ? (this.invoice?.InvoiceGroups || [])
      : this.getWorkedHoursGroups();

    return groups.some(group => (group?.InvoiceRows || []).some(row => !!row?.StartDate));
  }

  private validateTimeReportingChoice(): boolean {
    if (this.invoice?.SubInvoice || this.invoice?.CreditInvoiceFor != null
      || this.skipTimeReporting || this.hasReportedWorkDate()) {
      return true;
    }

    this.ErrorMessageSend = 'Du måste ange minst ett arbetat datum eller kryssa i "Jag väljer att avstå tidrapportering".';
    this.sendInvoiceValidates = false;
    return false;
  }

  hasWorkedHoursInvoiceGroup(): boolean {
    return this.getWorkedHoursInvoiceGroup() != null;
  }

  createOrEditWorkedHoursGroup(): void {
    if (this.isLoading || this.invoiceGroupSaving) {
      return;
    }

    this.enforceSingleWorkedHoursGroup(false);
    const existingGroup = this.getWorkedHoursInvoiceGroup();
    if (existingGroup) {
      this.editInvoiceCalendar(existingGroup);
      return;
    }

    const workCountry = this.toWorkCountryName(this.invoice?.WorkCountry) || this.invoice?.Customer?.Country?.Name || 'Sverige';
    const newGroup = {
      Id: this.newGuid(),
      Description: 'Arbetad tid',
      InvoiceRows: [],
      Type: { TechnicalName: this.workedHoursGroupType, Name: 'Arbetad tid' },
      TimeReportStatus: { DisplayName: 'Ingen tid', Id: '3', Name: 'NoInfo' },
      WorkingTitle: '',
      WorkCountry: workCountry,
      Vat: this.invoice?.Customer?.Country?.Id > 1 ? this.invoiceQuickGroup.VatNoSwe : this.invoiceQuickGroup.Vat,
      ReverseTax: this.reverseTaxTemp,
      Amount: 0,
      isNew: true
    };

    this.editInvoiceCalendar(newGroup);
  }

  referenceValidates() {
    // Reference required when customer is company
    return !(this.invoice.Customer.Id != undefined && this.invoice.Customer.IsCompany && !this.invoice.Reference?.Id);
  }

  validPreview() {
    try {
      const inv: any = this.invoice;
      if (!inv) { return false; }

      // Status: must be Draft/Utkast
      const tech = (inv.Status && inv.Status.TechnicalName) ? String(inv.Status.TechnicalName).toLowerCase() : '';
      const name = (inv.Status && inv.Status.Name) ? String(inv.Status.Name).toLowerCase() : '';
      const isDraft = tech === 'draft' || name === 'utkast';

      // Customer present
      const hasCustomer = !!(inv.Customer && ((inv.Customer.Id && Number(inv.Customer.Id) > 0) || (inv.Customer.Name && String(inv.Customer.Name).trim().length > 0)));

      // At least one group
      const hasGroup = Array.isArray(inv.InvoiceGroups) && inv.InvoiceGroups.length > 0;

      // Not RUT/ROT
      const notRotRut = !inv.IsRut && !inv.IsRot && !inv.IsRotRut;

      return isDraft && hasCustomer && hasGroup && notRotRut && this.validateTotalShareSalary();
    } catch { return false; }
  }

  saveQuickRow(group: any, openEdit: boolean) { 
    if (this.isInvoiceContentLocked()) return;
    if (this.invoiceGroupSaving) {
      return;
    }

    group.Id = this.newGuid();
    group.isNew = true;
    if (!this.usesLegacyInvoiceGroupMode()) {
      group.Type = { TechnicalName: this.invoiceItemGroupType, Name: this.invoiceItemGroupType };
      group.InvoiceRows = [];
      group.WorkingTitle = '';
    }
    else {
      this.clearWorkedHoursType(group);
    }
    group.WorkCountry = this.toWorkCountryName(this.invoice.WorkCountry) || this.invoice.Customer?.Country?.Name || 'Sverige';
    const selectedVat = this.isSwedishCustomer(this.invoice.Customer) ? group.Vat : group.VatNoSwe;
    group.Vat = this.normalizeInvoiceItemVatForCustomer(selectedVat, this.invoice.Customer, false);

    if (!this.isReverseTaxAllowedForCustomer(this.invoice.Customer)) {
      group.ReverseTax = false;
    }

    this.invoice.InvoiceGroups.push(group);
    this.setTotalHoursWorked();
    this.invoiceQuickGroup = JSON.parse(JSON.stringify(this.invoiceQuickGroupTemplate));
    this.invoiceQuickGroup.ReverseTax = this.reverseTaxTemp;
    this.applyCustomerVatRulesToQuickGroup(true);
    this.getVatList();

    

    if (openEdit) {
      this.editInvoiceCalendar(this.invoice.InvoiceGroups[this.invoice.InvoiceGroups.length - 1]);
    }

    //if (this.invoice.Customer.Country.Name != "Sverige" && !this.isAdmin) {
    //  group.Vat = "0";
    //}

    this.updateTotalInvoiceAmount();

  }

  public quickRowValidate() {

    if (this.invoiceQuickGroup.Description == '' || this.invoiceQuickGroup.Description == ' ') {
      this.ErrorMessageTab = '';
    }

    this.checkForbiddenSymbols(this.invoiceQuickGroup.Description);

  }

  validateGln(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']; // Allow basic navigation keys
    const isNumber = /[0-9]/.test(event.key);

    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
      this.sendInvoiceValidates = false;
    }
    else {
      this.sendInvoiceValidates = true;
    }
  }

  public checkForbiddenSymbols(description: any) {

    var regex = /^[-a-öA-Ö0-9,./&€%;+:@!?()= \r\n]*[^|¤"–]$/g;
    var inputIsValid = regex.test(description);

    if (inputIsValid) {
      this.quickrowValid = true;
      this.ErrorMessageDesc = '';
      return true;
    }
    else {
      this.quickrowValid = false;
      this.ErrorMessageDesc = 'Beskrivningen är tom eller innehåller otillåtna tecken eller tabbar. Godkänt innehåll är a-ö, A-Ö, 0-9 samt , . ! ( ) ? / -';
      return false;
    }
  }

  get hasDuplicateInvoiceEmails(): boolean {
    const recipient = (this.invoice.RecieverEmail || '').trim().toLowerCase();
    const reminder = (this.invoice.RecieverEmailReminder || '').trim().toLowerCase();
    const addresses = [recipient, ...this.invoiceCopyEmailAddresses]
      .map(address => (address || '').trim().toLowerCase()).filter(address => address !== '');
    return new Set(addresses).size !== addresses.length || (!!recipient && reminder === recipient);
  }

  get invoiceCopyEmailAddresses(): string[] {
    return (this.invoice.RecieverEmailCopy || '').split(',');
  }

  trackCopyEmailIndex(index: number): number {
    return index;
  }

  updateInvoiceCopyEmail(index: number, address: string) {
    if (!this.canUpdateGeneral()) return;
    const addresses = this.invoiceCopyEmailAddresses;
    addresses[index] = address.trim();
    this.invoice.RecieverEmailCopy = addresses.join(',');
    this.checkCorrectEmailFormat(this.invoice.RecieverEmailCopy, 'RecieverEmailCopy');
    this.sendValidates();
  }

  canAddInvoiceCopyEmail(): boolean {
    const addresses = this.invoiceCopyEmailAddresses;
    return this.canUpdateGeneral() && this.recieverEmailCopyValid && !this.hasDuplicateInvoiceEmails
      && !!addresses[addresses.length - 1].trim();
  }

  addInvoiceCopyEmail() {
    if (!this.canAddInvoiceCopyEmail()
      || !this.checkCorrectEmailFormat(this.invoice.RecieverEmailCopy, 'RecieverEmailCopy')) return;
    this.invoice.RecieverEmailCopy += ',';
    this.checkCorrectEmailFormat(this.invoice.RecieverEmailCopy, 'RecieverEmailCopy');
    this.sendValidates();
  }

  removeInvoiceCopyEmail(index: number) {
    if (!this.canUpdateGeneral()) return;
    const addresses = this.invoiceCopyEmailAddresses;
    addresses.splice(index, 1);
    this.invoice.RecieverEmailCopy = addresses.join(',');
    this.checkCorrectEmailFormat(this.invoice.RecieverEmailCopy, 'RecieverEmailCopy');
    this.sendValidates();
  }

  public checkCorrectEmailFormat(email: any, type: string) {

    // Regular expression for a single valid email address
    var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    var inputIsValid;

    // If the type is 'RecieverEmailCopy', allow comma-separated emails
    if (type == 'RecieverEmailCopy') {
      if (email != '' && email != null) {
        inputIsValid = email.split(',').map((e: string) => e.trim()).filter((e: string) => e !== '').every((e: string) => regex.test(e));
      }
    } else {
      inputIsValid = regex.test(email);
    }

    if (inputIsValid || email == '' || email == null) {

      if (type == 'RecieverEmail') {
        this.ErrorMessageRecieverEmail = '';
        this.recieverEmailValid = true;
      }
      if (type == 'RecieverEmailCopy') {
        this.ErrorMessageRecieverCopyEmail = '';
        this.recieverEmailCopyValid = true;
      }
      if (type == 'RecieverEmailReminder') {
        this.ErrorMessageRecieverReminderEmail = '';
        this.recieverEmailReminderValid = true;

      }



      return true;
    }
    else {
      if (type == 'RecieverEmail') {
        this.ErrorMessageRecieverEmail = 'E-postadressen har fel format';
        this.recieverEmailValid = false;
      }
      if (type == 'RecieverEmailCopy') {
        this.ErrorMessageRecieverCopyEmail = 'E-postadressen har fel format';
        this.recieverEmailCopyValid = false;
      }
      if (type == 'RecieverEmailReminder') {
        this.ErrorMessageRecieverReminderEmail = 'E-postadressen har fel format';
        this.recieverEmailReminderValid = false;
      }
      return false;
    }
  }


  saveQuickRowValidates() {

    if ((this.invoiceQuickGroup.Description == '' || this.invoiceQuickGroup.Description == ' ') && this.invoiceQuickGroup.Amount > 0) {
      this.errorMessageSaveQuickRow = 'Du har inte angivit någon beskrivning.'
    }

    else if (this.invoiceQuickGroup.Description != '' && (this.invoiceQuickGroup.Amount < 0 || this.invoiceQuickGroup.Amount > 0)) {
      this.errorMessageSaveQuickRow = 'Du har inte angivit något belopp.'
    }

    if (this.invoiceQuickGroup.Description != '' && this.invoiceQuickGroup.Description != ' ' && (this.invoiceQuickGroup.Amount < 0 || this.invoiceQuickGroup.Amount > 0)) {
      this.errorMessageSaveQuickRow = '';
      return true;
    }
    else {
      return false;
    }
  }

  checkTimeReportStatusRutRot() {
    if (this.invoice.IsRot || this.invoice.IsRut) {

      for (var group in this.invoice.InvoiceGroups) {
        if (this.invoiceQuickGroup.TimeReportStatus.Name == 'DetailedInfo') {
          this.rutRotValidates = true;
          this.errorMessageSaveQuickRow = '';
          return true;
        }
        else {
          //this.errorMessageSaveQuickRow = 'Vid RUT/ROT krävs att du anger arbetad tid'
          this.rutRotValidates = false;
          break;
        }
      }
    }
    else {
      this.errorMessageSaveQuickRow = "";
      return true;
    }
  }

  timeReportValidates() {
    if (this.invoice.Customer.TimeReportMandatory) {
      if (this.invoiceQuickGroup.TimeReportStatus.Name == 'DetailedInfo') {
        this.errorMessageSaveQuickRow = '';
        return true;
      }
      else {
        this.errorMessageSaveQuickRow = 'Din kund kräver att du uppger detaljerad tid.'
        return false;
      }
    }
    else if (this.invoice.IsRot || this.invoice.IsRut) {
      if (this.invoiceQuickGroup.TimeReportStatus.Name == 'DetailedInfo') {
        this.errorMessageSaveQuickRow = '';
        return true;
      }
      else {
        this.errorMessageSaveQuickRow = 'Vid RUT/ROT krävs att du anger arbetad tid'
        return false;
      }
    }
    else {
      return true;
    }
  }

  editInvoiceCalendar(calendarGroup: any) {
    if (this.isInvoiceContentLocked()) return;
    if (this.invoiceGroupSaving) {
      return;
    }

    const calendarConfig: any = {
      ...this.config,
      width: '900px',
      maxWidth: 'calc(100vw - 32px)',
      height: 'auto',
      maxHeight: 'calc(100vh - 32px)',
      panelClass: 'invoice-calendar-dialog',
      data: { ...this.config.data }
    };
    calendarConfig.data.invoiceItemGroup = calendarGroup;
    calendarConfig.data.status = this.invoice.Status.TechnicalName;
    calendarConfig.data.customerCountryName = this.invoice.Customer.Country.Name;
    calendarConfig.data.isRotRut = (this.invoice.IsRot === true || this.invoice.IsRut === true);
    calendarConfig.data.workCountry = this.toWorkCountryName(this.invoice.WorkCountry) || this.invoice.Customer?.Country?.Name || 'Sverige';
    calendarConfig.data.canEditWorkedHours = this.canEditWorkedHoursGroup();

    calendarConfig.data.customer = JSON.parse(JSON.stringify(this.invoice.Customer || { TimeReportMandatory: false }));

    if (calendarConfig.data.customer != null && calendarConfig.data.customer.TimeReportMandatory == null) {
      calendarConfig.data.customer.TimeReportMandatory = false;
    }

    if (!Array.isArray(calendarConfig.data.invoiceItemGroup.InvoiceRows)) {
      calendarConfig.data.invoiceItemGroup.InvoiceRows = [];
    }

    if (!calendarConfig.data.invoiceItemGroup.TimeReportStatus) {
      calendarConfig.data.invoiceItemGroup.TimeReportStatus = { DisplayName: "Ingen tid", Id: "3", Name: "NoInfo" };
    }

    calendarConfig.data.alwaysShowAllFields = this.usesLegacyInvoiceGroupMode();
    calendarConfig.data.invoiceItemGroup.TimeReportStatus = calendarGroup.TimeReportStatus || calendarConfig.data.invoiceItemGroup.TimeReportStatus;
    let dialogRef = this.dialog.open(InvoiceToolCalendarDialogComponent, calendarConfig);



    dialogRef.afterClosed().subscribe((result: any) => {


      var updated = false;
      if (result != undefined) {
        if (!this.usesLegacyInvoiceGroupMode()) {
          if (this.isWorkedHoursGroup(result)) {
            result.Type = { ...(result.Type || {}), TechnicalName: this.workedHoursGroupType, Name: 'Arbetad tid' };
            result.Description = 'Arbetad tid';
            result.Amount = 0;
          }
          else {
            result.Type = { ...(result.Type || {}), TechnicalName: this.invoiceItemGroupType, Name: this.invoiceItemGroupType };
            result.InvoiceRows = [];
            result.WorkingTitle = '';
          }
        }
        else {
          this.clearWorkedHoursType(result);
        }

        if (!this.usesLegacyInvoiceGroupMode() && this.isWorkedHoursGroup(result)) {
          const existingWorkedHoursGroup = this.invoice.InvoiceGroups.find(group => this.isWorkedHoursGroup(group) && group.Id !== result.Id);
          const hasResultGroup = this.invoice.InvoiceGroups.some(group => group.Id === result.Id);

          if (existingWorkedHoursGroup && !hasResultGroup) {
            this.showDuplicateWorkedHoursWarning('Det finns redan en grupp för Arbetad tid. Ändringarna sparas på den befintliga gruppen.');
            result.Id = existingWorkedHoursGroup.Id;
          }
        }

        const resultWorkCountry = this.toWorkCountryName(result.WorkCountry).trim();
        if (resultWorkCountry !== '') {
          this.invoice.WorkCountry = resultWorkCountry;
        }

        for (var i = 0; i < this.invoice.InvoiceGroups.length; i++) {
          if (this.invoice.InvoiceGroups[i].Id === result.Id) {
            if (result.action == 'delete') {
              this.invoice.InvoiceGroups.splice(i, 1);
            }
            else {
              this.invoice.InvoiceGroups[i] = result;
            }

            //if (this.invoice.Customer.Country.Name != "Sverige" && !this.isAdmin) {
            //  this.invoice.InvoiceGroups[i].Vat = "0";
            //}

            updated = true;
            break;
          }



        }

        if (!updated && this.invoice.action != 'delete')
          this.invoice.InvoiceGroups.push(result);

        if (!this.usesLegacyInvoiceGroupMode() && this.isWorkedHoursGroup(result)) {
          this.enforceSingleWorkedHoursGroup(true, result.Id);
        }

        this.refreshInvoiceGroupsUi();

        //this.workCalendarList = result;
        this.setTotalHoursWorked();
        this.persistInvoiceGroupImmediately(result);

      }

      this.updateTotalInvoiceAmount();
      this.updatePensionSavingsAmount();


      dialogRef = null;
    });
  }

  preview(invoice: any) {

    var config = JSON.parse(JSON.stringify(this.config));
    config.height = '80%';
    config.width = '80%';
    config.data = this.invoice;
    config.data.TotalInvoiceAmount = this.TotalInvoiceAmount;


    let dialogRef = this.dialog.open(InvoicePreviewDialogComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {

      dialogRef = null;
    });
  }

  InvoiceSendMethodChange(type: any) {

    if (type == undefined || type == 0)
      type = 1;

    this.invoice.InvoiceSendType = type;

    if (type == 2) { // Mail
      this.invoice.InvoiceSendMethodMail = true;
      this.invoice.InvoiceSendMethodEmail = false;
    }
    else if (type == 1) { // Email
      this.invoice.InvoiceSendMethodMail = false;
      this.invoice.InvoiceSendMethodEmail = true;
    }

  }

  private persistInvoiceGroupImmediately(group: any): void {
    if (this.isInvoiceContentLocked()) return;
    if (!group || !this.invoice || this.invoice.Id <= 0 || group.action === 'delete') {
      return;
    }

    if (this.isWorkedHoursGroup(group)) {
      this.enforceSingleWorkedHoursGroup(true, group.Id);
    }

    this.invoiceGroupSaving = true;
    const clientId = group.Id;
    const localSnapshot = JSON.parse(JSON.stringify(group));
    const payload = this.prepareInvoiceGroupPayload(group);

    this.invoiceService.saveInvoiceGroup(this.invoice.Id, payload, this.isWorkedHoursGroup(group))
      .subscribe((savedGroup: any) => {
        if (!savedGroup) {
          this.invoiceGroupSaving = false;
          return;
        }

        const mergedGroup = this.mergeSavedInvoiceGroup(savedGroup, localSnapshot);
        this.replaceInvoiceGroupAfterSave(clientId, mergedGroup);
        if (this.isWorkedHoursGroup(mergedGroup)) {
          this.enforceSingleWorkedHoursGroup(true, mergedGroup.Id);
        }
        this.setTotalHoursWorked();
        this.updateTotalInvoiceAmount();
        this.updatePensionSavingsAmount();
        this.invoiceGroupSaving = false;
      }, (error: any) => {
        console.error('Kunde inte spara fakturagruppen direkt', error);
        this.invoiceGroupSaving = false;
      });
  }

  private prepareInvoiceGroupPayload(group: any): any {
    const payload = JSON.parse(JSON.stringify(group));
    this.ensurePersistableTimeReportStatusForTypeLessGroup(payload);
    if (!this.usesLegacyInvoiceGroupMode()) {
      if (this.isWorkedHoursGroup(payload)) {
        payload.Type = { ...(payload.Type || {}), TechnicalName: this.workedHoursGroupType, Name: 'Arbetad tid' };
        payload.Description = 'Arbetad tid';
        payload.Amount = 0;
      }
      else {
        payload.Type = { ...(payload.Type || {}), TechnicalName: this.invoiceItemGroupType, Name: this.invoiceItemGroupType };
        payload.InvoiceRows = [];
        payload.WorkingTitle = '';
      }
    }
    else {
      this.clearWorkedHoursType(payload);
    }

    payload.Id = this.toPositiveId(payload.Id);

    if (Array.isArray(payload.InvoiceRows)) {
      payload.InvoiceRows = payload.InvoiceRows.map(row => {
        const normalizedRow = { ...row };
        normalizedRow.Id = this.toPositiveId(normalizedRow.Id);
        return normalizedRow;
      });
    }

    if (Array.isArray(payload.Deductions)) {
      payload.Deductions = payload.Deductions.map(deduction => {
        const normalizedDeduction = { ...deduction };
        normalizedDeduction.Id = this.toPositiveId(normalizedDeduction.Id);
        return normalizedDeduction;
      });
    }

    if (Array.isArray(payload.Allowances)) {
      payload.Allowances = payload.Allowances.map(allowance => {
        const normalizedAllowance = { ...allowance };
        normalizedAllowance.Id = this.toPositiveId(normalizedAllowance.Id);
        return normalizedAllowance;
      });
    }

    // WorkCountry is handled at invoice level, not invoice-group endpoint.
    delete payload.WorkCountry;
    delete payload.action;
    delete payload.isNew;

    return payload;
  }

  private toPositiveId(value: any): number {
    if (typeof value === 'number' && isFinite(value) && value > 0) {
      return value;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      // Only accept pure decimal numeric ids. Prevent partial parse of GUIDs.
      if (/^\d+$/.test(trimmed)) {
        const parsed = Number(trimmed);
        if (isFinite(parsed) && parsed > 0) {
          return parsed;
        }
      }
    }

    return 0;
  }

  private replaceInvoiceGroupAfterSave(clientId: any, savedGroup: any): void {
    if (!this.invoice || !Array.isArray(this.invoice.InvoiceGroups)) {
      return;
    }

    if (this.usesLegacyInvoiceGroupMode()) {
      this.clearWorkedHoursType(savedGroup);
    }
    const index = this.invoice.InvoiceGroups.findIndex(group => group.Id === clientId || group.Id === savedGroup.Id);

    if (index >= 0) {
      this.invoice.InvoiceGroups[index] = savedGroup;
    } else {
      this.invoice.InvoiceGroups.push(savedGroup);
    }

    this.refreshInvoiceGroupsUi();
  }

  private mergeSavedInvoiceGroup(savedGroup: any, localGroup: any): any {
    if (!savedGroup) {
      return localGroup;
    }

    const merged = { ...(localGroup || {}), ...savedGroup };
    const savedRowsAreUsable = Array.isArray(savedGroup.InvoiceRows)
      && savedGroup.InvoiceRows.some(row => row && row.StartDate != null && String(row.StartDate).trim() !== '');

    if (
      !savedRowsAreUsable &&
      Array.isArray(localGroup?.InvoiceRows) &&
      localGroup.InvoiceRows.length > 0
    ) {
      merged.InvoiceRows = localGroup.InvoiceRows;
    }

    if (
      (!savedGroup.TimeReportStatus || !savedGroup.TimeReportStatus.Name) &&
      localGroup?.TimeReportStatus
    ) {
      merged.TimeReportStatus = localGroup.TimeReportStatus;
    }

    if ((savedGroup.Type == null || (typeof savedGroup.Type === 'object' && Object.keys(savedGroup.Type).length === 0)) && localGroup?.Type != null) {
      merged.Type = localGroup.Type;
    }

    return merged;
  }

  private refreshInvoiceGroupsUi(): void {
    if (!this.invoice || !Array.isArray(this.invoice.InvoiceGroups)) {
      return;
    }

    // Force a new array reference + explicit detectChanges so date rows appear immediately.
    this.invoice.InvoiceGroups = [...this.invoice.InvoiceGroups];
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  setTotalHoursWorked() {
    this.hoursWorkedTotal = 0;
    this.TotalInvoiceAmount = 0;

    for (var i = 0; i < this.invoice.InvoiceGroups.length; i++) {
      const group = this.invoice.InvoiceGroups[i];
      const amount = Number(group?.Amount) || 0;

      if (this.usesLegacyInvoiceGroupMode() || !this.isWorkedHoursGroup(group)) {
        this.TotalInvoiceAmount += amount;
      }

      // Quick add don´t have rows
      if (!this.isSubInvoice() && group.InvoiceRows != undefined) {

        for (var e = 0; e < group.InvoiceRows.length; e++) {
          const hoursWorked = parseFloat(group.InvoiceRows[e].HoursWorked) || 0;
          const minutesWorked = parseFloat(group.InvoiceRows[e].MinutesWorked) || 0;

          this.hoursWorkedTotal += hoursWorked;
          this.hoursWorkedTotal += minutesWorked / 60;
        }
      }
    }
  }

  updateTotalInvoiceAmount() {

    //Update total invoice amount when allowances or deductions are added to invoice (for customer to pay)
    this.setTotalHoursWorked();

    this.TotalInvoiceAmount = Number(this.TotalInvoiceAmount);

    for (var i = 0; i < this.invoice.Deductions.length; i++) {
      if (this.invoice.Deductions[i].AddedToInvoice == true) {
        this.TotalInvoiceAmount = Number(this.TotalInvoiceAmount + this.getBilledDeductionAmount(this.invoice.Deductions[i]));
      }
    }

    for (var i = 0; i < this.invoice.Allowances.length; i++) {
      const a = this.invoice.Allowances[i];
      if (a.AddedToInvoice == true) {
        // If mileage with custom billable rate per km, add the custom total to invoice
        if (a && a.AllowanceType && (a.AllowanceType.Id == '1' || a.AllowanceType.Id == 1) && a.CustomReimbursementPerKm && a.CustomReimbursementPerKm !== 0 && a.sumCustomReimbursementPerKm) {
          this.TotalInvoiceAmount = Number(this.TotalInvoiceAmount + a.sumCustomReimbursementPerKm);
        } else {
          // Default: add tax-free sum
          this.TotalInvoiceAmount = Number(this.TotalInvoiceAmount + a.Sum);
        }
      }
    }

    this.calculateRotRut();

    this.invoice.TotalInvoiceAmount = Number(this.TotalInvoiceAmount);

  }

  private getBilledDeductionAmount(deduction: IDeduction): number {
    return Number(deduction && deduction.AgreedInvoiceAmount != null
      ? deduction.AgreedInvoiceAmount
      : deduction && deduction.Amount) || 0;
  }

  calculateRotRut() {

    //If changed to foreign country / company, invoice can't have rot/rut (null-safe)
    const customer = this.invoice ? this.invoice.Customer : null;
    const isCompany = customer ? customer.IsCompany === true : false;
    const isForeign = (customer && customer.Country && typeof customer.Country.Name === 'string')
      ? customer.Country.Name !== 'Sverige'
      : false;
    if (isForeign || isCompany) {
      this.invoice.IsRot = false;
      this.invoice.IsRut = false;
    }

    if (this.invoice.RotDrivingFeeTotalAmount !== 0 && (this.invoice.IsRot || this.invoice.IsRut)) {
      this.TotalInvoiceAmount += this.invoice.RotDrivingFeeTotalAmount;
    }


  }

  addCustomer() {

    var ownerId = this.invoice.User != undefined ? this.invoice.User.Id : undefined;

    // remove previous edit
    this.config.data.customer = undefined;

    this.config.data.customerTemplate = { Id: 0, User: { Id: ownerId }, Country: { Id: 1, Name: 'Sverige' }, IsCompany: true };


    let dialogRef = this.dialog.open(EditCustomerDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: ICompany) => {

      if (result != undefined) {

        this.companies.push(result);

        // Remove this, check for empty
        this.invoice.Customer = {
          Active: result.Active,
          AcceptsInvoiceFee: result.AcceptsInvoiceFee,
          AcceptsInvoiceFeeLocked: result.AcceptsInvoiceFeeLocked,
          Address: result.Address,
          AddressLocked: result.AddressLocked,
          City: result.Address,
          CityLocked: result.CityLocked,
          ElectronicReference: result.ElectronicReference,
          ElectronicReferenceMandatory: result.ElectronicReferenceMandatory,
          GlnNumber: result.GlnNumber,
          GlnNumberLocked: result.GlnNumberLocked,
          InvoiceSendType: result.InvoiceSendType,
          InvoiceSendTypeLocked: result.InvoiceSendTypeLocked,
          Id: result.Id,
          InvoiceEmail: result.InvoiceEmail,
          InvoiceEmailLocked: result.InvoiceEmailLocked,
          Name: result.InvoiceEmail,
          NameLocked: result.NameLocked,
          OrgNumber: result.OrgNumber,
          PaymentTerm: result.PaymentTerm,
          PaymentTermLocked: result.PaymentTermLocked,
          PublicInfo: result.PublicInfo,
          Reference: result.Reference,
          TimeReportMandatory: result.TimeReportMandatory,
          Zip: result.Zip,
          ZipLocked: result.ZipLocked,
          Contacts: [],
          IsCompany: result.IsCompany,
          Country: { Id: null, Name: null, Eu: false }
        };


        this.UpdateCompany(result, this.invoice.Customer);
        this.disableExpressPayoutIfIneligible(true);

        this.setInvoiceEmail(this.invoice.Customer.InvoiceEmail);
        this.setRecieverAddress();
        this.setElectronicReferenceText();
        this.getInvoicePaymentTerm();
        this.applyCustomerVatRulesToInvoiceItems(true);
        this.applyCustomerVatRulesToQuickGroup(true);
        this.getVatList();
      }

      this.setLockedValues(this.invoice.Customer);


      dialogRef = null;
    });
  }

  addContact() {

    this.config.data.contact = undefined;
    this.config.data.companyId = this.invoice.Customer.Id;
    let dialogRef = this.dialog.open(EditContactDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: IContact) => {

      if (result != undefined) {
        this.addSavedContact(result, this.invoice.Customer.Id);
      }

      this.checkReferenceEmail(this.invoice.Reference.Email);

      dialogRef = null;
    });
  }

  editContact(contact: IContact) {
    this.config.data.contact = contact;
    this.config.data.companyId = this.invoice.Customer.Id;
    let dialogRef = this.dialog.open(EditContactDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: IContact) => {
      if (result) {
        this.invoice.Reference.Name = result.Name;
        this.invoice.Reference.Email = result.Email;
        this.invoice.Reference.Phone = result.Phone;

        this.checkReferenceEmail(this.invoice.Reference.Email);

        for (let i = 0; i < this.contacts.length; i++) {
          const contact = this.contacts[i];
          if (contact.Id === result.Id) {
            contact.Name = result.Name;
            contact.Email = result.Email;
            contact.Phone = result.Phone;
          }
        }
      }

      dialogRef = null;
    });
  }

  checkReferenceEmail(email: string) {
    const freeEmailDomains = [
      'gmail.com',
      'hotmail.com',
      'hotmail.se',
      'outlook.com',
      'yahoo.com',
      'live.com',
      'icloud.com',
      'aol.com',
      'protonmail.com',
      'msn.com',
      'yandex.com',
      'zoho.com',
      'mail.com',
      'gmx.com'
    ];

    if (!email || email.indexOf('@') === -1) {
      this.ContactEmailApprovedForExpress = false;
      return;
    }

    const domain = email.split('@')[1].toLowerCase();
    this.ContactEmailApprovedForExpress = !freeEmailDomains.includes(domain);
  }

  setInvoiceEmail(email: string) {

    this.invoice.RecieverEmail = JSON.parse(JSON.stringify(email));
    this.invoice.InvoiceSendMethodEmail = true;
    this.invoice.InvoiceSendMethodMail = false;

    this.checkCorrectEmailFormat(this.invoice.RecieverEmail, 'RecieverEmail');
  }

  setLockedValues(customer) {

    if (this.invoice.Customer.InvoiceSendTypeLocked == true) {
      this.invoice.InvoiceSendType = customer.InvoiceSendType;
      this.invoiceSendTypeLocked = true;
    }
    else {
      this.invoiceSendTypeLocked = false;
    }

    if (customer.AcceptsInvoiceFeeLocked) {
      if (!customer.AcceptsInvoiceFee) {
        this.invoice.FeePaidByReciever = false;
        this.invoiceFeeLocked = true;
      }
    }
    else {
      this.invoiceFeeLocked = false;
    }

    if (customer.InvoiceEmailLocked) {
      this.invoice.RecieverEmail = customer.InvoiceEmail;
      this.recieverEmailLocked = true;
    }
    else {
      this.recieverEmailLocked = false;
    }

    if (customer.InvoiceSendTypeLocked) {
      this.invoice.InvoiceSendType = customer.InvoiceSendType;
      this.invoiceSendTypeLocked = true;
    }
    else {
      this.invoiceSendTypeLocked = false;
    }

    if (customer.ElectronicReferenceMandatory) {
      this.invoice.ReferenceText = this.invoice.Customer.ElectronicReference;
      this.electronicReferenceMandatory = true;
    }
    else {
      this.electronicReferenceMandatory = false;
    }

    this.getInvoicePaymentTerm();

  }

  setRecieverAddress() {
    this.invoice.RecieverCompanyName = this.invoice.Customer.Name;
    this.invoice.RecieverAddress1 = this.invoice.Customer.Address;
    this.invoice.RecieverZip = this.invoice.Customer.Zip;
    this.invoice.RecieverCity = this.invoice.Customer.City;
  }

  setElectronicReferenceText() {
    this.invoice.ReferenceText = this.invoice.Customer.ElectronicReference;
  }

  setCountryName(country: string) {
    this.invoice.Customer.Country.Name = JSON.parse(JSON.stringify(country));
    this.applyCustomerVatRulesToInvoiceItems(true);
    this.applyCustomerVatRulesToQuickGroup(true);
    this.getVatList();
  }

  private toWorkCountryName(value: any): string {
    if (value == null) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'object' && typeof value.Name === 'string') {
      return value.Name;
    }

    return String(value);
  }

  isPreNotifiedInvoiceRow(row: any, group?: any): boolean {
    if (!row) {
      return false;
    }

    if (this.isPreNotifiedFlag(row.IsPreNotified) || this.isPreNotifiedFlag(row.isPreNotified)) {
      return true;
    }

    if (row.PreNotifiedAt != null || row.preNotifiedAt != null) {
      return true;
    }

    const hasExplicitPreNotifiedProps =
      Object.prototype.hasOwnProperty.call(row, 'IsPreNotified') ||
      Object.prototype.hasOwnProperty.call(row, 'isPreNotified') ||
      Object.prototype.hasOwnProperty.call(row, 'PreNotifiedAt') ||
      Object.prototype.hasOwnProperty.call(row, 'preNotifiedAt');

    if (hasExplicitPreNotifiedProps) {
      return false;
    }

    const invoiceAny = this.invoice as any;
    const invoiceWorkNoticeStatus = invoiceAny?.WorkNoticeStatus?.TechnicalName;
    const invoiceStatus = invoiceAny?.Status?.TechnicalName;
    const invoiceIsPreNotified =
      invoiceWorkNoticeStatus === 'PreNotified' ||
      invoiceStatus === 'JobPreNotification';

    if (invoiceIsPreNotified && this.isWorkedHoursGroup(group)) {
      return true;
    }

    return false;
  }

  private isPreNotifiedFlag(value: any): boolean {
    if (value === true) {
      return true;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === '1' || normalized === 'true';
    }

    return false;
  }

  editCustomer() {

    this.config.data.customer = this.invoice.Customer;
    let dialogRef = this.dialog.open(EditCustomerDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((response: any) => {
      if (!response) {
        dialogRef = null;
        return;
      }

      this.updateCustomer(response);
      this.setInvoiceEmail(response.InvoiceEmail);
      this.setLockedValues(response);
      dialogRef = null;
    });


  }

  getCompanies() {

    // Get contacts from invoice data if invoice allready exists
    // Get from logged in user if new

    if (this.invoice.UserSettings != undefined || (this.isAdmin && this.invoice.Id > 0)) {
      this.companyService.getCompanies(this.invoice.UserSettings.Id, true)
        .subscribe(value => this.onGetCompaniesFinished(value),
          error => this.onGetCompaniesError(error)
        );
    }
    else {
      this.companyService.getMyCompanies()
        .subscribe(value => this.onGetCompaniesFinished(value),
          error => this.onGetCompaniesError(error)
        );
    }
  }

  onGetCompaniesError(error: any) {
  }

  onGetCompaniesFinished(companies: any) {
    setTimeout(() => {
      this.companies = companies;

      // Filter out customers that are not active in list for non-admin users
      if (!this.isAdmin) {
        const selectedId = (this.invoice && this.invoice.Customer) ? this.invoice.Customer.Id : null;
        this.companies = this.companies.filter(c => (c.ActiveInList !== false) || c.Id === selectedId);
      }

      this.companiesLoaded = true;
      this.cdr.detectChanges();
    }, 0);
  }

  customerChange(id) {
    
    this.invoice.Customer = this.getCustomer(id);
    this.disableExpressPayoutIfIneligible(true);
    this.updateCompanyStatus(this.invoice.Customer);
    this.setInvoiceEmail(this.invoice.Customer.InvoiceEmail);
    this.setRecieverAddress();
    this.setElectronicReferenceText();
    this.invoice.Reference = { ...this.ref };

    if (this.invoice.Customer.InvoiceSendType > 0) {
      this.invoice.InvoiceSendType = this.invoice.Customer.InvoiceSendType;
    }
    else {
      this.invoice.InvoiceSendType = 1;
    }
    this.setLockedValues(this.invoice.Customer);
    this.getInvoicePaymentTerm();
    this.applyCustomerVatRulesToInvoiceItems(true);
    this.applyCustomerVatRulesToQuickGroup(true);
    this.getVatList();
    this.getCompanyContacts(id);
  }

  updateCompanyStatus(customer) {
    if (!customer || !customer.OrgNumber) {
      return;
    }

    this.companyService.getGlobalCompanyByOrgNr(customer.OrgNumber)
      .subscribe(response => {
        const resolved = Array.isArray(response) ? response[0] : response;
        if (!resolved || typeof resolved.Active !== 'boolean') {
          return;
        }
        this.invoice.Customer.Active = resolved.Active;

        if (!this.invoice.Customer.Active) {
          var config = JSON.parse(JSON.stringify(this.config));
          config.height = 370;
          config.width = 400;
          config.data.hideInput = true;
          config.data.requireInput = false;
          config.data.hideCancelButton = true;
          config.data.headline = "Företaget inaktivt!"
          config.data.confirmButtonText = "Ok!";
          config.data.confirmButtonIcon = "check";
          config.data.text = "Företaget <b>" + customer.Name + "</b> är inaktivt.<br><br>Det org.nr. du angett har status inaktivt, konkurs eller annat som gör att vi inte kan hitta dess data. Är du säker på att organisationsnumret är korrekt så kontakta supporten genom att maila support@samgruppen.se så återkommer vi så snart vi kan";

          let dialogRef = this.dialog.open(ConfirmDialogComponent, config);
        }
      });
  }
  getCompanyContacts(companyId: number) {
    this.contactsLoaded = false;
    this.companyService.getCompanyContacts(companyId)
      .subscribe(
        response => {
          setTimeout(() => {
            this.contacts = response || [];
            this.contactsLoaded = true;
            this.cdr.detectChanges();
          }, 0);
        },
        error => {
          this.contacts = [];
          this.contactsLoaded = true;
          alert('Ett fel inträffade!');
        }
      );
  }

  contactChange(contactId: number) {
    const contact = this.contacts.find(contact => contact.Id == contactId);
    // Keep the invoice separate from the dropdown options when changing customer or contact.
    this.invoice.Reference = contact ? { ...contact } : { ...this.ref };
    this.checkReferenceEmail(this.invoice.Reference.Email);
    this.sendValidates();
  }

  addSavedContact(contact: IContact, companyId: number) {
    this.contacts.push(contact);
    this.contactChange(contact.Id);
    this.cdr.markForCheck();
  }

  getCustomer(id) {
    for (var i = 0; i < this.companies.length; i++) {
      if (this.companies[i].Id == this.invoice.Customer.Id) {
        return JSON.parse(JSON.stringify(this.companies[i]));
      }
    }
  }

  updateCustomerGlnNumber(glnNumber: string, customerID: number) {
    var customer = this.getCustomer(customerID) as ICompany;
    customer.GlnNumber = glnNumber;
    this.companyService.updateCompany(customer)
      .subscribe(response => this.onCustomerUpdated(response), error => alert('Ett fel inträffade när GLN skulle sparas!'));
  }

  onCustomerUpdated(response: any) {
    alert('Kundens GLN är uppdaterat!');
  }

  updateCustomer(company: ICompany) {

    for (var i = 0; i < this.companies.length; i++) {

      var currentCompany = this.companies[i];

      if (currentCompany.Id == company.Id) {
        this.UpdateCompany(company, currentCompany);
        this.UpdateCompany(company, this.invoice.Customer);
        this.disableExpressPayoutIfIneligible(true);
        this.applyCustomerVatRulesToInvoiceItems(true);
        this.applyCustomerVatRulesToQuickGroup(true);
        this.getVatList();
        return;
      }
    }
  }

  uploadDocument(event: any, documentList: any) {

    // Created new file placeholder
    let file = {
      FileType: {} as IFileType
    } as IFile;
    // Give it an id
    file.Guid = this.newGuid();
    file.FileType.TechnicalName = "AttachedInvoiceDocument";
    let fileList: FileList = event.target.files

    if (fileList.length > 0) {
      let f: File = fileList[0];
      file.Name = f.name;

      if (f.size > 5242880) {
        alert('Filen är för stor, max 5 Mb')
        // Rensa filinmatningen så filnamnet inte visas kvar
        if (event && event.target) {
          try { event.target.value = null; } catch { /* ignore */ }
        }
        return; // avbryt uppladdning
      }
      else {

        this.invoiceService.uploadDocument(f, file.Guid, 'AttachedInvoiceDocument')
          .subscribe(
            response => this.onAttachedDocumentSaved(response, file),
            error => console.log(error));
      }
    }
  }

  onAttachedDocumentSaved(response: any, file: IFile) {

    file.Id = response.Id;
    file.Guid = response.Guid;
    file.Url = response.Url;
    file.FileSize = response.FileSize;
    file.FileType = response.FileType;

    const fileExtension = file.Name.split('.').pop().toLowerCase();

    if (fileExtension !== 'pdf') {
      alert("Du får enbart ladda upp pdf-filer");
    } else {
      // Ensure Documents array is initialized
      if (!this.invoice.Documents) {
        this.invoice.Documents = [];
      }
      this.invoice.Documents.push(file);

    }

    this.checkTotalAttachmentSize(this.invoice.Documents);
    this.cdr.markForCheck();
  }


  checkTotalAttachmentSize(documentList: Array<IFile>) {

    this.totalFileSize = 0;
    this.attachedFilesCount = 0;

    if (documentList != null) {
      for (var i = 0; i < documentList.length; i++) {

        if (documentList[i].FileType.TechnicalName == 'AttachedInvoiceDocument') {
          this.totalFileSize = this.totalFileSize += documentList[i].FileSize;

          this.attachedFilesCount = this.attachedFilesCount + 1;
        }

      }
    }
  }

  checkFileExtension(documentList: Array<IFile>) {
    for (var i = 0; i < documentList.length; i++) {

      if (documentList[i].FileType.TechnicalName == 'AttachedInvoiceDocument') {
        var fileName = documentList[i].Name;
        var fileExtension = fileName.split('.').pop();
      }
    }
  }

  deleteDocumentFromList(file: IFile, documentList: Array<IFile>) {

    if (confirm("Vill du radera filen " + file.Name + " ?")) {
      for (var i = 0; i < documentList.length; i++) {
        if (documentList[i].Guid == file.Guid) {
          documentList.splice(i, 1);
        }
      }
    }

    this.checkTotalAttachmentSize(documentList);
  }

  showFile(file: IFile) {
    this.fileService.openFile(file);
  }

  addDeduction() {
    this.invoice.Deductions.push({ Attachment: { Guid: this.newGuid() }, VatPercentage: "25", Description: '', IncludeInInvoice: true, TravelExpense: false });
  }

  addSalaryShare() {
    var newShare = {
      Guid: this.newGuid(),
      PersonalNumber: '',
      SearchAccountValue: '',
      SearchAccountValid: false,
      SearchAccountPersonalNumber: '',
      PendingSearchAccountPersonalNumber: '',
      Share: undefined,
      ShareType: {
        Id: undefined
      },
      SalaryReciever: {
        Id: undefined
      }
    };

    this.searchAccountValue = "";
    this.personalOrOrgNumberValid = false;

    if (this.invoice.SalaryShares === null) {
      this.invoice.SalaryShares = []; // Initialize the SalaryShares array if it is null
    }

    this.invoice.SalaryShares.push(newShare);
  }

  addInvoiceDocument() {

    var newDocument = {
      Guid: this.newGuid(),
      FileType: {
        TechnicalName: 'AttachedInvoiceDocument'
      },
    };

    this.searchAccountValue = "";
    this.personalOrOrgNumberValid = false;

    this.invoice.SalaryShares.push(newDocument);
  }

  openAddUserAccountModal(salaryShare) {

    this.config.data.contact.IDNumber = salaryShare.SearchAccountPersonalNumber || this.normalizeSalarySharePersonalNumber(salaryShare.SearchAccountValue);

    let dialogRef = this.dialog.open(AddMissingRecieverDialogComponent, this.config);

    dialogRef.afterClosed().subscribe(accountSetting => {
      this.SearchAccount(salaryShare.SearchAccountValue, salaryShare)
    });

  }

  SearchAccount(term: string, salaryShare: any) {

    const normalizedPersonalNumber = this.normalizeSalarySharePersonalNumber(term);
    const personalNumberValid = normalizedPersonalNumber.length == 12;

    salaryShare.SearchAccountValue = term;
    salaryShare.SearchAccountValid = personalNumberValid;
    salaryShare.SearchAccountPersonalNumber = normalizedPersonalNumber;

    if (term == null || term == "") {
      salaryShare.SalaryReciever = { Id: undefined };
      salaryShare.PersonalNumber = '';
      salaryShare.PendingSearchAccountPersonalNumber = '';
      return;
    }

    if (personalNumberValid) {
      salaryShare.PendingSearchAccountPersonalNumber = normalizedPersonalNumber;

      this.userService.getUserByPersonalOrOrgNumber(normalizedPersonalNumber)
        .subscribe(
          response => this.onSearchAccountCompleted(response, salaryShare, normalizedPersonalNumber),
          error => console.log(error));
    }

  }

  onSearchAccountCompleted(response: IAccountSettings, salaryShare: any, requestedPersonalNumber: string) {

    if (salaryShare.PendingSearchAccountPersonalNumber != requestedPersonalNumber) {
      return;
    }

    const responsePersonalNumber = this.normalizeSalarySharePersonalNumber(response?.PersonalNumber);

    if (response?.Id != null && responsePersonalNumber == requestedPersonalNumber) {
      salaryShare.SalaryReciever = response;
      salaryShare.PersonalNumber = requestedPersonalNumber;
    }
    else {
      salaryShare.SalaryReciever = { Id: undefined };
      salaryShare.PersonalNumber = '';
    }


    // Check if user is not allready in list
    //if (response.Id > 0) {

    //  

    //  for (var i = 0; i < this.invoice.SalaryShares.length; i++) {
    //    var share = this.invoice.SalaryShares[i];

    //    if (share.SalaryReciever.Id > 0 && share.SalaryReciever.Id == response.Id) {
    //      salaryShare.Delete = true;
    //      alert('Användaren finns redan i listan!');
    //    }
    //    else {
    //      salaryShare.SalaryReciever = response;
    //    }
    //  }


    //  for (var i = 0; i < this.invoice.SalaryShares.length; i++) {
    //    var share = this.invoice.SalaryShares[i];

    //    if (share.Delete) {
    //      this.deleteShare(i);
    //    }
    //  }
    //}
  }

  deleteShare(shareIndex: number) {
    this.invoice.SalaryShares.splice(shareIndex, 1);
  }

  invoiceSendTypeOnChange(sendTypeId: number) {

  }

  UpdateCompany(from: any, to: any) {
    to.Name = from.Name;
    to.Address = from.Address;
    to.Address2 = from.Address2;
    to.Co = from.Co;
    to.Zip = from.Zip;
    to.City = from.City;
    to.Phone = from.Phone;
    to.Email = from.Email;
    to.InvoiceEmail = from.InvoiceEmail;
    to.OrgNumber = from.OrgNumber;
    to.Reference = from.Reference;
    to.IsCompany = from.IsCompany;
    to.GlnNumber = from.GlnNumber;
    to.Country = from.Country;
    to.InvoiceSendType = from.InvoiceSendType;

    if (from.InvoiceSendType > 0) {
      this.invoice.InvoiceSendType = from.InvoiceSendType;
    }
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }

  updatePensionSavingsCompany(companyId: number) {
    this.userService.updatePensionSavingsCompany(this.invoiceSender.Id, companyId)
      .subscribe(response => this.onPensionSavingsCompanyUpdated(response), error => console.log(error));
  }

  onPensionSavingsCompanyUpdated(companyId) {
    this.pensionSavingsCompanyId = companyId;
  }

  canSaveBankInfo(): boolean {
    return this.invoiceSenderBankDetailsAreValid(false);
  }

  hasMissingUserInfo(): boolean {
    return !!(this.missingEmail || this.missingPhone || this.missingPersonalNumber);
  }

  async saveUserContactAndBankInfo() {
    if (this.userInfoSaving || this.userInfoSaveValid()) {
      return;
    }

    this.userInfoSaving = true;
    let errorMessage = 'Kunde inte spara personuppgifter.';
    try {
      // Persist the personal number before validating a new Nordea personkonto on the server.
      if (this.missingEmail || this.missingPhone || this.missingPersonalNumber) {
        await firstValueFrom(this.userService.updateCurrentUser({
          email: this.missingEmail,
          phone: this.missingPhone,
          personalNumber: this.missingPersonalNumber,
          systemAppId: this.appId.toString()
        }));
        if (this.missingPersonalNumber) { this.invoiceSender.PersonalNumber = this.missingPersonalNumber; }
        this.missingEmail = '';
        this.missingPhone = '';
        this.missingPersonalNumber = '';
        this.onUserInfoUpdated();
      }

      errorMessage = 'Kunde inte spara bankuppgifter.';
      if (this.bankInfoNeedsUpdate && this.invoiceSenderBankDetailsAreValid(true)) {
        const bankId = await firstValueFrom(this.userService.updateUserBankInfo(
          this.invoiceSender.Id,
          this.invoiceSender.Bank.Id,
          this.invoiceSender.ClearingNumber,
          this.invoiceSender.AccountNumber,
          this.invoiceSender.Bic,
          this.invoiceSender.Iban
        ));
        this.onBankInfoUpdated(bankId);
      }
    } catch (err: any) {
      this.showMessage(err?.error?.message || errorMessage);
    } finally {
      this.userInfoSaving = false;
    }
  }

  onUserInfoUpdated() {
    this.userEmailNeedsUpdate = false;
    this.userPhoneNumberNeedsUpdate = false;
    this.userPersonalNumberNeedsUpdate = false;
    this.userInfoNeedsUpdate = false;
    this.showMessage('Personuppgifter uppdaterade!');
  }

  onBankInfoUpdated(bankId) {
    this.invoiceSender.Bank.Id = bankId;
    this.bankInfoNeedsUpdate = false; 
  }

  showMessage(message: string) {
    let config = new MatSnackBarConfig();
    config.duration = 7000;
    this.snackBar.open(message, undefined, config);
  }

  // Ensures the whole value matches the bank regex (HTML pattern is implicitly anchored)
  private fullRegexTest(pattern: string, value: string): boolean {
    if (!pattern) { return false; }
    const trimmed = pattern.trim();
    const anchored = (trimmed.startsWith('^') && trimmed.endsWith('$'))
      ? trimmed
      : `^(?:${trimmed})$`;
    try {
      return new RegExp(anchored).test(value || '');
    } catch {
      // If pattern from backend is malformed, fail closed (treat as invalid)
      return false;
    }
  }

  userInfoSaveValid(): boolean {
    if (this.bankValidationTimer != null) { return true; }
    const bankInvalid = this.bankInfoNeedsUpdate && !this.invoiceSenderBankDetailsAreValid(false);

    const personalNumberInvalid = this.userPersonalNumberNeedsUpdate && (!this.missingPersonalNumber || !/^\d{12}$/.test(this.missingPersonalNumber));
    const emailInvalid = this.userEmailNeedsUpdate && (!this.missingEmail || !/.+@.+\..+/.test(this.missingEmail));
    const phoneInvalid = this.userPhoneNumberNeedsUpdate && (!this.missingPhone || this.missingPhone.length < 6); // customize this if needed

    return bankInvalid || personalNumberInvalid || emailInvalid || phoneInvalid;
  }

  private invoiceSenderBankDetailsAreValid(normalizeForSave: boolean): boolean {
    if (!this.invoiceSender || !this.invoiceSender.Bank || !this.invoiceSender.Bank.Id) {
      return false;
    }

    if (this.invoiceSender.Bank.IsInternational) {
      const bic = (this.invoiceSender.Bic || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
      const iban = (this.invoiceSender.Iban || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
      const isValid = /^[A-Z]{6}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/.test(bic) && /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban);

      if (isValid && normalizeForSave) {
        this.invoiceSender.Bic = bic;
        this.invoiceSender.Iban = iban;
      }

      return isValid;
    }

    const result = this.swedishBankAccountValidationService.validate(
      this.banks,
      this.bankEntryMode === 'personkonto' ? null : this.invoiceSender.ClearingNumber,
      this.invoiceSender.AccountNumber,
      this.getBankPersonalNumber()
    );

    if (!result.isValid || !result.resolvedBank || result.resolvedBank.Id !== this.invoiceSender.Bank.Id) {
      return false;
    }

    if (normalizeForSave) {
      this.invoiceSender.ClearingNumber = this.bankEntryMode === 'personkonto' ? '' : result.normalizedClearingNumber;
      this.invoiceSender.AccountNumber = result.normalizedAccountNumber;
      this.invoiceSender.BankName = result.resolvedBankName;
    }

    return true;
  }

  validateTotalShareSalary(): boolean {
    if (!this.invoice.SalaryShares || this.invoice.CreditInvoiceFor != null) {
      return true;
    }

    let totalShareSalary = 0;
    let totalPercentage = 0;
    let shareTypeName: string | null = null;
    this.shareTypeDifferent = false;
    this.sharePercentExceedsTotal = false;
    this.shareAmountExceedsTotal = false;

    for (let share of this.invoice.SalaryShares) {
      if (!shareTypeName) {
        shareTypeName = share.ShareType.Name;
      } else if (shareTypeName !== share.ShareType.Name) {
        this.shareTypeDifferent = true;
        return false;
      }

      if (share.ShareType.Name === 'Procent' && share.Share) {
        totalPercentage += share.Share;
        totalShareSalary += (this.preliminaryPayout * (share.Share / 100));
      } else if (share.ShareType.Name === 'Fakturabelopp' && share.Salary) {
        totalShareSalary += share.Salary;
      }
    }

    if (shareTypeName === 'Procent' && totalPercentage > 100) {
      this.sharePercentExceedsTotal = true;
    } else if (shareTypeName === 'Fakturabelopp') {
      const allowedPayout = this.preliminaryPayout - this.sumNetExpenses;
      if (totalShareSalary > allowedPayout) {
        this.shareAmountExceedsTotal = true;
      }
    }

    return !this.shareTypeDifferent && !this.sharePercentExceedsTotal && !this.shareAmountExceedsTotal;
  }

  getSalaryShareValidationErrorMessage(): string {
    if (this.shareTypeDifferent) {
      return "Du kan inte blanda procent och belopp i l\u00f6nedelningarna.";
    }

    if (this.shareAmountExceedsTotal) {
      const payoutMinusExpenses = Math.round(this.preliminaryPayout - this.sumNetExpenses);
      return `Summan av l\u00f6nedelningarna p\u00e5 denna faktura \u00e4r st\u00f6rre \u00e4n den summa du har fakturerat (minus v\u00e5ra avgifter och dina avdrag). Du kan inte dela mer \u00e4n ${payoutMinusExpenses} SEK. De avdrag du gjort betalas alltid ut till dig som skickar fakturan.`;
    }

    if (this.sharePercentExceedsTotal) {
      return "Dina l\u00f6nedelningar blir mer \u00e4n 100 % tillsammans. Du kan inte dela mer \u00e4n 100 % av fakturabeloppet.";
    }

    return '';
  }

  saveDraft(invoice: any) {
    if (this.isInvoiceContentLocked()) return;
    if (this.isLoading) {
      return;
    }

    var createOffering = false;

    if (!this.validateFixedPensionAmount() || !this.validatePensionLimit()) return;
    this.calculatePreliminaryPayout();
    this.validatePensionSavingsCompany();

    if (this.requiresPensionSavingsCompany()) {
      this.ErrorMessageSend = this.errorMessagePensionSavingsCompany;
      this.sendInvoiceValidates = false;
      this.showValidationSummary = true;
      return;
    }

    if (this.invoice.Status.TechnicalName !== 'Draft' && !this.pensionValidates) {
      const errorMessage = this.errorMessagePensionSavingsCompany || this.errorMessagePension;
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
    }

    if (this.invoice.Reference.Id == 0) {
      this.invoice.Reference = null;
    }

    if (this.stopIfDuplicateWorkedHoursGroups()) {
      return;
    }

    this.enforceSingleWorkedHoursGroup(true);

    if (!this.canUpdateGeneral()) {
      this.isLoading = true;
      this.reseTmpIds();
      this.updateInvoice(invoice, 'Fakturan uppdaterad!', createOffering);
      return;
    }

    if (this.canUpdateInvoiceDraft()) {
      this.isLoading = true;
      this.reseTmpIds();

      if (createOffering) {
        invoice.Status = { Name: 'Offert begärd', TechnicalName: 'OfferingRequested' };
      }
      else {
        invoice.Status = invoice.Status || { Name: 'Utkast' };
      }

      if (!invoice.Id) {
        this.createInvoice(invoice, 'Fakturan skapad!', createOffering);
      }
      else {
        this.updateInvoice(invoice, 'Fakturan uppdaterad!', createOffering);
      }
    }
    else {
      this.submitType = 1;
      this.showValidationSummary = true;
    }
  }

  private updateInvoice(invoice: any, message: string, createOffering: boolean) {
    this.invoiceService.updateInvoice(invoice, message, undefined, createOffering)
      .subscribe(response => this.onDraftSaved(response, createOffering), error => {
        this.isLoading = false;
        console.log(error);
        this.showInvoiceSaveError(error, createOffering);
      });
  }

  private createInvoice(invoice: any, message: string, createOffering: boolean) {
    this.invoiceService.createInvoice(invoice, message, undefined, createOffering)
      .subscribe(response => this.onDraftSaved(response, createOffering), error => {
        this.isLoading = false;
        console.log(error);
        this.showInvoiceSaveError(error, createOffering);
      });
  }

  private showInvoiceSaveError(error?: any, createOffering: boolean = false): void {
    const apiError = error?.error;
    const details = typeof apiError === 'string'
      ? apiError
      : apiError?.ExceptionMessage || apiError?.Message || apiError?.message || apiError?.title || error?.message;
    const subject = createOffering ? 'Offertbegäran' : 'Fakturan';
    const message = details
      ? `${subject} kunde inte sparas. ${details}`
      : `${subject} kunde inte sparas. Försök igen eller kontakta support om felet kvarstår.`;

    this.snackBar.open(message, 'Stäng', { duration: 10000 });
  }

  private hasBillableExpenses(): boolean {
    const deductions = this.invoice && this.invoice.Deductions ? this.invoice.Deductions : [];
    const allowances = this.invoice && this.invoice.Allowances ? this.invoice.Allowances : [];
    const groups = this.invoice && this.invoice.InvoiceGroups ? this.invoice.InvoiceGroups : [];

    return deductions.some(d => d && d.AddedToInvoice == true) ||
      allowances.some(a => a && a.AddedToInvoice == true) ||
      groups.some(g =>
        (g && g.Deductions && g.Deductions.some(d => d && d.AddedToInvoice == true)) ||
        (g && g.Allowances && g.Allowances.some(a => a && a.AddedToInvoice == true)));
  }

  private clearBillableExpenses(): void {
    const deductions = this.invoice && this.invoice.Deductions ? this.invoice.Deductions : [];
    const allowances = this.invoice && this.invoice.Allowances ? this.invoice.Allowances : [];
    const groups = this.invoice && this.invoice.InvoiceGroups ? this.invoice.InvoiceGroups : [];

    deductions.forEach(d => { if (d) { d.AddedToInvoice = false; } });
    allowances.forEach(a => { if (a) { a.AddedToInvoice = false; } });

    groups.forEach(g => {
      if (g && g.Deductions) {
        g.Deductions.forEach(d => { if (d) { d.AddedToInvoice = false; } });
      }

      if (g && g.Allowances) {
        g.Allowances.forEach(a => { if (a) { a.AddedToInvoice = false; } });
      }
    });

    this.updateTotalInvoiceAmount();
  }

  private hasBillableExpensesInForeignCurrency(): boolean {
    return this.invoice?.Currency?.Name !== 'SEK' && this.hasBillableExpenses();
  }

  showForeignCurrencyBillableExpensesWarning(): boolean {
    return this.hasBillableExpensesInForeignCurrency();
  }

  getForeignCurrencyBillableExpensesErrorMessage(): string {
    return 'Utlägg/avdrag och reseersättningar kan enbart vidarefaktureras om valutan är SEK.\nKlicka ur "Faktureras kund" eller lägg till beloppet som vanliga fakturarader.';
  }

  private openPayoutToggleForBilledDeduction(deduction: IDeduction): void {
    if (deduction && deduction.AddedToInvoice === true) {
      this.invoiceExpenseToggleOpen = true;
      this.payoutDeductionsToggleOpen = true;
    }
  }

  private openPayoutToggleForBilledAllowance(allowance: IAllowance): void {
    if (allowance && allowance.AddedToInvoice === true) {
      this.payoutAllowancesToggleOpen = true;
    }
  }

  checkInvoiceGroups(): boolean {
    const hasNoInvoiceGroups = !this.invoice.InvoiceGroups || this.invoice.InvoiceGroups.length === 0;
    return hasNoInvoiceGroups && this.hasBillableExpenses();
  }

  send(invoice: any, createOffering: boolean = false) {
    if (this.isInvoiceContentLocked()) return;
    if (this.isLoading) {
      return;
    }

    if (!this.validateTimeReportingChoice()) {
      alert(this.ErrorMessageSend);
      return;
    }

    if (this.stopIfDuplicateWorkedHoursGroups()) {
      return;
    }

    if (!this.validateFixedPensionAmount() || !this.validatePensionLimit()) return;
    this.calculatePreliminaryPayout();

    // 👉 check if InvoiceGroups exist
    if (this.hasBillableExpensesInForeignCurrency()) {
      this.ErrorMessageSend = this.getForeignCurrencyBillableExpensesErrorMessage();
      this.sendInvoiceValidates = false;
      alert(this.ErrorMessageSend);
      return;
    }

    if (this.checkInvoiceGroups()) {
      const proceed = confirm(
        "Du har lagt till avdrag/reseersättningar, men inga fakturarader. " +
        "Vill du endast fakturera dina utlägg/reseersättningar, eller avbruta och lägga till fakturarader?\n\n" +
        "Klicka på OK för att skicka med endast avdrag/ersättningar.\n" +
        "Klicka på Avbryt för att avbryta och redigera fakturan."
      );

      if (!proceed) {
        return; // ❌ stop sending, user wants to edit
      }
    }

    if (this.invoice.SalaryShares && this.invoice.SalaryShares.length > 0) {
      this.validateTotalShareSalary();

      if (this.invoice.CreditInvoiceFor == null || this.invoice.CreditInvoiceFor == 0) {
        if (this.shareTypeDifferent) {
          alert("Du kan inte blanda procent och belopp i lönedelningarna.");
          return;
        }

        if (this.shareAmountExceedsTotal) {
          const payoutMinusExpenses = Math.round(this.preliminaryPayout - this.sumNetExpenses);
          alert(`Summan av lönedelningarna på denna faktura är större än den summa du har fakturerat (minus våra avgifter och dina avdrag). Du kan inte dela mer än ${payoutMinusExpenses} SEK. De avdrag du gjort betalas alltid ut till dig som skickar fakturan.`);
          return;
        }

        if (this.sharePercentExceedsTotal) {
          alert("Dina lönedelningar blir mer än 100 % tillsammans. Du kan inte dela mer än 100 % av fakturabeloppet.");
          return;
        }

        if (this.invoice.Currency.Name === 'SEK' && this.sumNetExpenses > this.preliminaryPayout && !this.isAdmin) {
          alert(`Summan av dina utlägg/ersättningar är större än den summa du har fakturerat (minus våra avgifter). Du kan inte göra avdrag som är större än ${this.preliminaryPayout} SEK.`);
          return;
        }
      }
    }

    if (!this.invoice.Customer.IsCompany) {
      this.invoice.ExpressPayOut = false;
    }

    this.enforceSingleWorkedHoursGroup(true);

    if (this.canUpdateInvoice()) {
      this.isLoading = true;

      this.reseTmpIds();

      if (this.invoice.Status.TechnicalName == "Draft" || this.invoice.Status.TechnicalName == "OfferingRequested" || this.invoice.Status.TechnicalName == "OfferingSent") {
        if (createOffering) {
          invoice.Status = { Name: 'Offert begärd', TechnicalName: 'OfferingRequested' };
        }
        else {
          invoice.Status = { Name: 'Granskas', TechnicalName: 'UnderReview' };
        }
      }

      if (invoice.Id == undefined || invoice.Id == 0) {
        //this.invoiceService.createInvoice(invoice, 'Fakturan skapad!', undefined)
        //  .subscribe(
        //    response => this.onDraftSaved(response),
        //    error => console.log(error));
        this.createInvoice(invoice, 'Fakturan skapad!', createOffering);
      }
      else {

        //this.invoiceService.updateInvoice(invoice, 'Fakturan uppdaterad!', undefined)
        //  .subscribe(
        //    response => this.onDraftSaved(response),
        //    error => console.log(error));
        this.updateInvoice(invoice, 'Fakturan uppdaterad!', createOffering);
      }
    }
    else {
      this.submitType = 2;
      this.showValidationSummary = true;
    }

    //if (this.rbExpressPayoutYes.checked == true) {
    //  this.invoice.ExpressPayOut = true;
    //}
    //else {
    //  this.invoice.ExpressPayout = false;
    //}
  }

  reseTmpIds() {

    for (var i = 0; i < this.invoice.InvoiceGroups.length; i++) {
      if (this.usesLegacyInvoiceGroupMode()) {
        this.clearWorkedHoursType(this.invoice.InvoiceGroups[i]);
      }
      // Kontrollera och uppdatera InvoiceGroup.Id
      if (!(typeof this.invoice.InvoiceGroups[i].Id === 'number' && this.invoice.InvoiceGroups[i].Id > 0)) {
        this.invoice.InvoiceGroups[i].Id = 0;
      }

      // Kontrollera och uppdatera InvoiceRow.Id inom varje InvoiceGroup
      if (Array.isArray(this.invoice.InvoiceGroups[i].InvoiceRows)) {
        for (var j = 0; j < this.invoice.InvoiceGroups[i].InvoiceRows.length; j++) {
          if (!(typeof this.invoice.InvoiceGroups[i].InvoiceRows[j].Id === 'number' && this.invoice.InvoiceGroups[i].InvoiceRows[j].Id > 0)) {
            this.invoice.InvoiceGroups[i].InvoiceRows[j].Id = 0;
          }
        }
      }
    }


    for (var i = 0; i < this.invoice.Deductions.length; i++) {
      if (!(typeof this.invoice.Deductions[i].Id === 'number' && this.invoice.Deductions[i].Id > 0)) {
        this.invoice.Deductions[i].Id = 0;
      }
    }

    for (var i = 0; i < this.invoice.Allowances.length; i++) {
      if (!(typeof this.invoice.Allowances[i].Id === 'number' && this.invoice.Allowances[i].Id > 0)) {
        this.invoice.Allowances[i].Id = 0;
      }
    }

  }

  private ensurePersistableTimeReportStatusForTypeLessGroup(group: any): void {
    if (!group) {
      return;
    }

    const rows = Array.isArray(group.InvoiceRows) ? group.InvoiceRows : [];
    if (rows.length === 0) {
      return;
    }

    const type = group.Type;
    const directTypeId = group.TypeId;
    const hasDirectTypeId = directTypeId != null
      && String(directTypeId).trim() !== ''
      && Number(String(directTypeId).trim()) > 0;
    const hasNestedTypeId = !!(type && type.Id != null && String(type.Id).trim() !== '' && Number(String(type.Id).trim()) > 0);
    const hasTypeId = hasDirectTypeId || hasNestedTypeId;
    if (hasTypeId) {
      return;
    }

    if (!group.TimeReportStatus || typeof group.TimeReportStatus !== 'object') {
      group.TimeReportStatus = { Id: "3", Name: "NoInfo", DisplayName: "Ingen tid" };
      return;
    }

    const statusName = typeof group.TimeReportStatus.Name === 'string'
      ? group.TimeReportStatus.Name.trim()
      : '';
    const statusId = typeof group.TimeReportStatus.Id === 'string' || typeof group.TimeReportStatus.Id === 'number'
      ? String(group.TimeReportStatus.Id).trim()
      : '';

    if (statusName === 'NoInfo' || statusId === '3') {
      group.TimeReportStatus.Id = "3";
      group.TimeReportStatus.Name = "NoInfo";
      group.TimeReportStatus.DisplayName = "Ingen tid";
      return;
    }

    if (statusName === 'DetailedInfo' || statusId === '1') {
      group.TimeReportStatus.Id = "1";
      group.TimeReportStatus.Name = "DetailedInfo";
      group.TimeReportStatus.DisplayName = "Detaljerad tid";
      return;
    }

    if (statusName === 'SumTime' || statusId === '2') {
      group.TimeReportStatus.Id = "2";
      group.TimeReportStatus.Name = "SumTime";
      group.TimeReportStatus.DisplayName = "Summerad tid";
      return;
    }

    if (statusName === '' && statusId === '') {
      // No active selection should default to no time information on the invoice.
      group.TimeReportStatus.Id = "3";
      group.TimeReportStatus.Name = "NoInfo";
      group.TimeReportStatus.DisplayName = "Ingen tid";
    }
  }

  private clearWorkedHoursType(group: any): void {
    if (!group || !group.Type) {
      return;
    }

    const hasId = group.Type.Id !== undefined && group.Type.Id !== null && String(group.Type.Id).trim() !== '';
    const hasValue = group.Type.Value !== undefined && group.Type.Value !== null && String(group.Type.Value).trim() !== '';
    const technicalName = typeof group.Type.TechnicalName === 'string'
      ? group.Type.TechnicalName.trim().toLowerCase()
      : '';
    const name = typeof group.Type.Name === 'string'
      ? group.Type.Name.trim().toLowerCase()
      : '';
    const hasExplicitTypeData = hasId || hasValue || technicalName !== '' || name !== '';

    if (!hasExplicitTypeData || technicalName === 'workedhours' || name === 'arbetad tid') {
      group.Type = {};
    }
  }


  // True if invoice already sent (any Sent*)
  isInvoiceAlreadySent(): boolean {
    const name = (this.invoice && this.invoice.Status && this.invoice.Status.TechnicalName) ? this.invoice.Status.TechnicalName : '';
    return typeof name === 'string' && name.startsWith('Sent');
  }

  // True if selected payment term exceeds 30 days
  paymentTermTooLongForExpress(): boolean {
    const term = parseInt(this.invoice && this.invoice.PaymentTerm ? this.invoice.PaymentTerm : '0', 10);
    return !!this.invoice && term > 30;
  }

  // True if invoice is sent and term > 30 (disables choosing Express afterwards)
  isSentAndTermTooLong(): boolean {
    const term = parseInt(this.invoice && this.invoice.PaymentTerm ? this.invoice.PaymentTerm : '0', 10);
    return this.isInvoiceAlreadySent() && term > 30;
  }

  // True if status is not Draft and payment term > 30
  isNotDraftAndTermTooLong(): boolean {
    const name = (this.invoice && this.invoice.Status && this.invoice.Status.TechnicalName) ? this.invoice.Status.TechnicalName : '';
    const term = parseInt(this.invoice && this.invoice.PaymentTerm ? this.invoice.PaymentTerm : '0', 10);
    return name !== 'Draft' && term > 30;
  }


  config = {
    disableClose: false,
    panelClass: 'full-screen-modal',
    hasBackdrop: true,
    backdropClass: '',
    width: '600px',
    maxWidth: '98vw',
    height: '90%',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      invoiceItemGroup: {
        TimeReportStatus: {}
      },
      customerTemplate: {},
      customer: { TimeReportMandatory: this.invoice.Customer.TimeReportMandatory },
      contact: { IDNumber: null },
      companyId: 0,
      status: {},
      deduction: {} as IDeduction,
      allowance: {} as IAllowance,
      customerCountryName: null,
      userId: null,
      invoiceCurrencyName: null,
      isRotRut: false
    },
    dataTemplate: {
      Id: 0,
      Country: { Id: 1 },
      Type: {},
      HoursWorked: undefined,
      StartDate: undefined,
      EndDate: undefined,
      Comment: undefined,
      InvoiceId: 0,
    }
  };

  configSpinner = {
    disableClose: true,
    panelClass: 'full-screen-modal',
    hasBackdrop: true,
    backdropClass: '',
    width: '400px',
    minHeight: '200px',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
  };

  // Opens invoice preview dialog
  openInvoicePreview() {
    try {
      const cfg: any = {
        disableClose: false,
        panelClass: 'full-screen-modal',
        hasBackdrop: true,
        maxWidth: '98vw',
        width: '900px',
        height: '90%',
        data: this.invoice
      };
      this.dialog.open(InvoicePreviewDialogComponent, cfg);
    } catch (e) {
      console.log(e);
    }
  }

  scrollToInvoiceSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  

}
